/* global window, document, fetch, Survey */

(function (window, document) {
    var root = document.getElementById('company-profile-root');
    if (!root) return;

    function qs(sel, el) {
        return (el || document).querySelector(sel);
    }

    function setStatus(msg) {
        var el = qs('[data-company-profile-status]', root);
        if (el) el.textContent = msg || '';
    }

    function setBarHidden(hidden) {
        var bar = qs('[data-profilebar]', root);
        if (!bar) return;
        bar.hidden = !!hidden;
    }

    function initialFromName(nameOrEmail) {
        var s = String(nameOrEmail || '').trim();
        if (!s) return '';
        if (s.indexOf('@') !== -1) s = s.split('@')[0];
        var parts = s.split(/\s+/).filter(Boolean);
        var a = parts[0] ? parts[0][0] : '';
        return String(a || '').toUpperCase();
    }

    function fmtDate(isoOrTs) {
        if (!isoOrTs) return '';
        var d = null;
        if (typeof isoOrTs === 'number') d = new Date(isoOrTs);
        else d = new Date(String(isoOrTs));
        if (isNaN(d.getTime())) return String(isoOrTs);
        return d.toLocaleDateString('it-IT', { year: 'numeric', month: '2-digit', day: '2-digit' });
    }

    function pickTierName(res) {
        var tiers = res && res.plans && res.plans.active_tiers ? res.plans.active_tiers : null;
        if (!tiers || !tiers.length) return '';
        var t = tiers[0] || null;
        if (!t) return '';
        if (t.name) return String(t.name);
        if (t.slug) return String(t.slug);
        return '';
    }

    function pickPlanLabel(res) {
        if (!res) return '—';
        var tierName = pickTierName(res);
        if (tierName) return 'Piano: ' + tierName;
        if (res.plans && res.plans.is_paid) return 'Piano: attivo';
        // Ghost can mark paid in different ways; fall back to status if present.
        var st = res.plans && res.plans.status ? String(res.plans.status) : '';
        if (st) return 'Piano: ' + st;
        if (res.member && res.member.paid === true) return 'Piano: attivo';
        return 'Piano: free';
    }

    function pickExpiry(res) {
        var subs = res && res.plans && res.plans.active_subscriptions;
        if (subs && subs.length && subs[0] && subs[0].current_period_end) {
            return 'Scadenza: ' + fmtDate(subs[0].current_period_end);
        }
        return '';
    }

    function renderProfileBar(res) {
        var member = res && res.member ? res.member : null;
        var claims = res && res.claims ? res.claims : null;
        var email = member && member.email ? String(member.email) : (claims && claims.sub ? String(claims.sub) : '');
        var name = member && member.name ? String(member.name) : (email || '—');

        var nameEl = qs('[data-name]', root);
        var emailEl = qs('[data-email]', root);
        var planEl = qs('[data-plan]', root);
        var expEl = qs('[data-expiry]', root);
        if (nameEl) nameEl.textContent = name || '—';
        if (emailEl) emailEl.textContent = email || '—';
        if (planEl) planEl.textContent = pickPlanLabel(res);
        if (expEl) expEl.textContent = pickExpiry(res);

        var img = qs('[data-avatar-img]', root);
        var fb = qs('[data-avatar-fallback]', root);
        var src = member && (member.avatar_image || member.profile_image || member.profile_image_url)
            ? String(member.avatar_image || member.profile_image || member.profile_image_url)
            : '';
        var fallbackLetter = initialFromName(name || email);

        function showFallback() {
            if (img) img.classList.add('vg-hidden');
            if (fb) fb.textContent = fallbackLetter;
        }

        function isBlankGravatar(url) {
            var u = String(url || '');
            return u.indexOf('gravatar.com/avatar') !== -1 && /[?&]d=blank\b/i.test(u);
        }

        if (!img || !src || isBlankGravatar(src)) {
            showFallback();
            return;
        }

        img.onerror = function () {
            showFallback();
        };
        img.src = src;
        img.classList.remove('vg-hidden');
        img.removeAttribute('aria-hidden');
        img.alt = name || 'Avatar';
        if (fb) fb.textContent = '';
    }

    function apiBase() {
        var base = (root.getAttribute('data-api-base') || '').trim();
        if (!base) return '/api';
        return base.replace(/\/+$/, '');
    }

    function openPortalSignin() {
        // Portal script is deferred; on cold loads it may not be ready yet.
        // We retry a few times and also set the hash as a fallback.
        var tries = 0;
        function attempt() {
            tries += 1;
            var a = qs('[data-company-profile-portal-signin]', root) || document.querySelector('[data-portal="signin"]');
            if (a && typeof a.click === 'function') {
                try { a.click(); } catch (e) {}
                return true;
            }
            // Fallback: set hash (Portal also supports routing via #/portal/...)
            try {
                if (window.location && window.location.hash !== '#/portal/signin') {
                    window.location.hash = '#/portal/signin';
                }
            } catch (e2) {}
            if (tries < 10) {
                window.setTimeout(attempt, 250);
            }
            return false;
        }
        return attempt();
    }

    async function fetchGhostSessionToken() {
        // Requires Ghost members cookies (same-origin).
        var r = await fetch('/members/api/session/', { method: 'GET', credentials: 'include' });
        if (r.status === 204) return null;
        if (!r.ok) {
            var txt = await r.text().catch(function () { return ''; });
            throw new Error('Ghost session fetch failed: HTTP ' + r.status + (txt ? ' ' + txt.slice(0, 200) : ''));
        }
        var token = await r.text();
        token = (token || '').trim();
        return token || null;
    }

    async function verifyOnGateway(sessionToken) {
        var url = apiBase() + '/auth/ghost/session/verify';
        var r = await fetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ session_token: sessionToken })
        });
        var data = null;
        try {
            data = await r.json();
        } catch (e) {
            var t = await r.text().catch(function () { return ''; });
            throw new Error('Gateway returned non-JSON: HTTP ' + r.status + (t ? ' ' + t.slice(0, 200) : ''));
        }
        if (!r.ok) {
            throw new Error('Gateway error: HTTP ' + r.status + ' ' + (data && data.detail ? data.detail : ''));
        }
        return data;
    }

    async function loginOnGateway(sessionToken) {
        var url = apiBase() + '/auth/ghost/session/login';
        var r = await fetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ session_token: sessionToken })
        });
        var data = null;
        try {
            data = await r.json();
        } catch (e) {
            var t = await r.text().catch(function () { return ''; });
            throw new Error('Gateway returned non-JSON: HTTP ' + r.status + (t ? ' ' + t.slice(0, 200) : ''));
        }
        if (!r.ok) {
            throw new Error('Gateway login error: HTTP ' + r.status + ' ' + (data && data.detail ? data.detail : ''));
        }
        return data;
    }

    async function apiJson(path, opts) {
        opts = opts || {};
        var url = apiBase() + path;
        var headers = opts.headers || {};
        headers.Accept = headers.Accept || 'application/json';
        if (opts.jsonBody) headers['Content-Type'] = 'application/json';
        var r = await fetch(url, {
            method: opts.method || 'GET',
            credentials: 'include',
            headers: headers,
            body: opts.jsonBody ? JSON.stringify(opts.jsonBody) : undefined
        });
        var data = null;
        if (r.status !== 204) {
            try {
                data = await r.json();
            } catch (e) {
                var t = await r.text().catch(function () { return ''; });
                var ct = '';
                try { ct = r.headers ? (r.headers.get('content-type') || '') : ''; } catch (e2) {}
                var hint = t ? (' ' + t.slice(0, 300)) : '';
                throw new Error('API non-JSON: HTTP ' + r.status + (ct ? (' [' + ct + ']') : '') + hint + ' (' + url + ')');
            }
        }
        if (!r.ok) {
            var detail = (data && data.detail != null) ? data.detail : '';
            var detailStr = '';
            try {
                if (typeof detail === 'string') detailStr = detail;
                else if (Array.isArray(detail)) detailStr = JSON.stringify(detail);
                else if (typeof detail === 'object') detailStr = JSON.stringify(detail);
                else detailStr = String(detail);
            } catch (e2) {
                detailStr = String(detail);
            }
            throw new Error('API error: HTTP ' + r.status + ' ' + detailStr + ' (' + url + ')');
        }
        return data;
    }

    function normalizeApiUrlMaybe(url) {
        var u = String(url || '').trim();
        if (!u) return '';
        var base = apiBase();
        // If backend stored a relative URL without /api prefix, fix it.
        if (u[0] === '/' && base && u.indexOf(base + '/') !== 0) {
            return base + u;
        }
        // If backend stored an absolute URL to same origin without /api prefix, fix it.
        try {
            var parsed = new URL(u, window.location.origin);
            var sameOrigin = parsed.origin === window.location.origin;
            if (sameOrigin && parsed.pathname && parsed.pathname.indexOf('/company-profiles/') === 0) {
                return base + parsed.pathname + (parsed.search || '');
            }
        } catch (e) {}
        return u;
    }

    function filenameFromContentDisposition(header, fallback) {
        var h = String(header || '');
        var m = /filename=\"?([^\";]+)\"?/i.exec(h);
        return (m && m[1]) ? m[1] : (fallback || 'download');
    }

    async function apiDownload(path, fallbackName) {
        var url = apiBase() + path;
        var r = await fetch(url, { method: 'GET', credentials: 'include' });
        if (!r.ok) {
            var errText = '';
            try { errText = await r.text(); } catch (e) {}
            throw new Error('Download fallito: HTTP ' + r.status + (errText ? ' ' + errText.slice(0, 200) : ''));
        }
        var blob = await r.blob();
        var fname = filenameFromContentDisposition(r.headers.get('content-disposition'), fallbackName);
        var a = document.createElement('a');
        var objUrl = URL.createObjectURL(blob);
        a.href = objUrl;
        a.download = fname;
        document.body.appendChild(a);
        a.click();
        setTimeout(function () {
            URL.revokeObjectURL(objUrl);
            a.remove();
        }, 0);
        return fname;
    }

    function ensureCpActivityLogModal() {
        var existing = document.getElementById('vg-cp-activity-log-modal');
        if (existing) return existing;
        var wrap = document.createElement('div');
        wrap.id = 'vg-cp-activity-log-modal';
        wrap.className = 'vg-kanban-modal vg-cp-log-modal';
        wrap.setAttribute('hidden', 'hidden');
        wrap.setAttribute('role', 'dialog');
        wrap.setAttribute('aria-modal', 'true');
        wrap.innerHTML =
            '<div class="vg-kanban-modal__panel" role="document">' +
            '  <h2 class="vg-kanban-modal__title">Registro export / restore</h2>' +
            '  <p class="vg-kanban-modal__message" data-cp-log-empty hidden>Nessuna attività registrata.</p>' +
            '  <div class="vg-cp-log-table-wrap" data-cp-log-table-wrap hidden>' +
            '    <table class="vg-cp-log-table">' +
            '      <thead><tr><th>Data</th><th>Operazione</th><th>Esito</th><th>Dettaglio</th></tr></thead>' +
            '      <tbody data-cp-log-body></tbody>' +
            '    </table>' +
            '  </div>' +
            '  <div class="vg-kanban-modal__actions">' +
            '    <button type="button" class="vg-kanban-modal__btn" data-cp-log-close>Chiudi</button>' +
            '  </div>' +
            '</div>';
        (document.body || document.documentElement).appendChild(wrap);
        return wrap;
    }

    function fmtDateTime(iso) {
        if (!iso) return '—';
        var d = new Date(String(iso));
        if (isNaN(d.getTime())) return String(iso);
        return d.toLocaleString('it-IT', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
    }

    function activityDetailText(detail) {
        if (!detail || typeof detail !== 'object') return '';
        if (detail.error) return String(detail.error);
        if (detail.filename) {
            var parts = [String(detail.filename)];
            if (detail.bytes) parts.push(String(detail.bytes) + ' B');
            if (detail.files) parts.push(detail.files + ' file');
            return parts.join(' · ');
        }
        if (detail.restore_summary && detail.restore_summary.attachments_restored != null) {
            return 'Allegati ripristinati: ' + detail.restore_summary.attachments_restored;
        }
        try { return JSON.stringify(detail).slice(0, 120); } catch (e) { return ''; }
    }

    async function openActivityLogModal(profileId) {
        if (!profileId) return;
        var modal = ensureCpActivityLogModal();
        var emptyEl = modal.querySelector('[data-cp-log-empty]');
        var tableWrap = modal.querySelector('[data-cp-log-table-wrap]');
        var tbody = modal.querySelector('[data-cp-log-body]');
        if (tbody) tbody.innerHTML = '<tr><td colspan="4">Caricamento…</td></tr>';
        modal.removeAttribute('hidden');
        document.documentElement.classList.add('vg-kanban-modal-lock');

        function closeModal() {
            modal.setAttribute('hidden', 'hidden');
            document.documentElement.classList.remove('vg-kanban-modal-lock');
        }

        var closeBtn = modal.querySelector('[data-cp-log-close]');
        if (closeBtn && !closeBtn.getAttribute('data-cp-log-bound')) {
            closeBtn.setAttribute('data-cp-log-bound', '1');
            closeBtn.addEventListener('click', closeModal);
            modal.addEventListener('click', function (e) {
                if (e.target === modal) closeModal();
            });
            document.addEventListener('keydown', function onKey(e) {
                if (!modal.hasAttribute('hidden') && e.key === 'Escape') closeModal();
            });
        }

        try {
            var data = await apiJson('/company-profiles/' + encodeURIComponent(profileId) + '/activity-log?limit=50');
            var items = (data && data.items) ? data.items : [];
            if (!items.length) {
                if (emptyEl) emptyEl.hidden = false;
                if (tableWrap) tableWrap.hidden = true;
                if (tbody) tbody.innerHTML = '';
                return;
            }
            if (emptyEl) emptyEl.hidden = true;
            if (tableWrap) tableWrap.hidden = false;
            if (tbody) {
                tbody.innerHTML = items.map(function (it) {
                    var ok = String(it.status || '') === 'success';
                    var statusCls = ok ? 'vg-cp-log-status--ok' : 'vg-cp-log-status--fail';
                    var statusLabel = ok ? 'OK' : 'Errore';
                    var detail = activityDetailText(it.detail);
                    return '<tr>' +
                        '<td>' + fmtDateTime(it.created_at) + '</td>' +
                        '<td>' + String(it.action_label || it.action || '') + '</td>' +
                        '<td class="' + statusCls + '">' + statusLabel + '</td>' +
                        '<td>' + detail + '</td>' +
                        '</tr>';
                }).join('');
            }
        } catch (err) {
            if (emptyEl) {
                emptyEl.hidden = false;
                emptyEl.textContent = 'Errore caricamento registro: ' + String(err.message || err);
            }
            if (tableWrap) tableWrap.hidden = true;
        }
    }

    function initProfileBarActions(profileId, opts) {
        opts = opts || {};
        var actions = qs('[data-cp-bar-actions]', root);
        if (!actions) return;
        if (!profileId) {
            actions.hidden = true;
            return;
        }
        actions.hidden = false;

        var exportMenu = qs('[data-cp-export-menu]', actions);
        var restoreBtn = qs('[data-cp-restore]', actions);
        var restoreInput = qs('[data-cp-restore-file]', actions);
        var logBtn = qs('[data-cp-activity-log]', actions);

        function closeExportMenu() {
            if (exportMenu && exportMenu.open) exportMenu.open = false;
        }

        if (exportMenu && !exportMenu.getAttribute('data-cp-export-bound')) {
            exportMenu.setAttribute('data-cp-export-bound', '1');
            exportMenu.querySelectorAll('[data-cp-export]').forEach(function (btn) {
                btn.addEventListener('click', async function () {
                    var kind = btn.getAttribute('data-cp-export');
                    closeExportMenu();
                    var pathMap = {
                        xlsx: '/export.xlsx',
                        pdf: '/export.pdf',
                        backup: '/export.backup.zip',
                        json: '/export.json'
                    };
                    var suffix = pathMap[kind];
                    if (!suffix) return;
                    try {
                        setStatus('Preparazione export…');
                        await apiDownload('/company-profiles/' + encodeURIComponent(profileId) + suffix);
                        setStatus('Export completato.');
                    } catch (err) {
                        setStatus(String(err.message || err));
                        if (window.VistaGareUi && VistaGareUi.alert) {
                            VistaGareUi.alert(String(err.message || err), { title: 'Export non riuscito' });
                        }
                    }
                });
            });
        }

        if (restoreBtn && restoreInput && !restoreBtn.getAttribute('data-cp-restore-bound')) {
            restoreBtn.setAttribute('data-cp-restore-bound', '1');
            restoreBtn.addEventListener('click', function () {
                restoreInput.value = '';
                restoreInput.click();
            });
            restoreInput.addEventListener('change', async function () {
                var file = restoreInput.files && restoreInput.files[0];
                if (!file) return;
                var ui = window.VistaGareUi;
                var ok = true;
                if (ui && ui.confirm) {
                    ok = await ui.confirm({
                        title: 'Ripristina backup',
                        message: 'Il backup sostituirà tutti i dati attuali del profilo. Continuare?',
                        confirmText: 'Ripristina',
                        cancelText: 'Annulla',
                        danger: true
                    });
                } else {
                    ok = window.confirm('Il backup sostituirà tutti i dati attuali del profilo. Continuare?');
                }
                if (!ok) return;
                try {
                    setStatus('Verifica sicurezza backup…');
                    var fd = new FormData();
                    fd.append('backup', file, file.name);
                    var url = apiBase() + '/company-profiles/' + encodeURIComponent(profileId) + '/restore';
                    var r = await fetch(url, { method: 'POST', credentials: 'include', body: fd });
                    var data = null;
                    try { data = await r.json(); } catch (e2) { data = null; }
                    if (!r.ok) {
                        var msg = (data && data.detail) ? String(data.detail) : ('HTTP ' + r.status);
                        throw new Error(msg);
                    }
                    setStatus('Ripristino completato.');
                    if (typeof opts.onRestored === 'function') await opts.onRestored(data);
                } catch (err) {
                    setStatus(String(err.message || err));
                    if (window.VistaGareUi && VistaGareUi.alert) {
                        VistaGareUi.alert(String(err.message || err), { title: 'Ripristino non riuscito' });
                    }
                } finally {
                    restoreInput.value = '';
                }
            });
        }

        if (logBtn && !logBtn.getAttribute('data-cp-log-bound')) {
            logBtn.setAttribute('data-cp-log-bound', '1');
            logBtn.addEventListener('click', function () {
                openActivityLogModal(profileId);
            });
        }
    }

    function europeBoundsLngLat() {
        return [[-25.0, 30.0], [45.0, 72.0]];
    }

    function expandBounds(bounds, factor) {
        factor = Number(factor || 1);
        if (!bounds || bounds.length !== 2 || factor <= 0) return bounds;
        var sw = bounds[0], ne = bounds[1];
        var w = Number(sw[0]), s = Number(sw[1]), e = Number(ne[0]), n = Number(ne[1]);
        if (!isFinite(w) || !isFinite(s) || !isFinite(e) || !isFinite(n)) return bounds;
        var cx = (w + e) / 2;
        var cy = (s + n) / 2;
        var hw = ((e - w) / 2) * factor;
        var hh = ((n - s) / 2) * factor;
        return [[cx - hw, cy - hh], [cx + hw, cy + hh]];
    }

    function clampMapToEurope(m) {
        if (!m) return;
        var EU = europeBoundsLngLat();
        try { if (m.setMaxBounds) m.setMaxBounds(EU); } catch (eB) {}
        try {
            if (m.cameraForBounds && m.setMinZoom) {
                var cam = m.cameraForBounds(EU, { padding: 24 });
                if (cam && isFinite(cam.zoom)) m.setMinZoom(Math.max(0, cam.zoom - 0.25));
            }
        } catch (eZ) {}
    }

    function stripTrailingZerosToPrefix(codeDigits) {
        var d = String(codeDigits || '').replace(/\D/g, '');
        if (!d) return '';
        var stripped = d.replace(/0+$/, '');
        return stripped || d;
    }

    function attachCpvAutocomplete(survey) {
        // Reuse the same CPV suggest endpoint used by radar pages.
        var cache = Object.create(null); // key: query -> items[]

        function fetchSuggest(q) {
            var qs = String(q || '').trim();
            if (!qs) return Promise.resolve([]);
            if (cache[qs]) return Promise.resolve(cache[qs]);
            var url = apiBase() + '/radar/hub/cpv-suggest?q=' + encodeURIComponent(qs) + '&limit=15';
            return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'include' })
                .then(function (r) { return r.ok ? r.json() : { items: [] }; })
                .then(function (data) {
                    var items = (data && data.items) ? data.items : [];
                    cache[qs] = items;
                    return items;
                })
                .catch(function () { return []; });
        }

        function ensureDatalist(input, dlId) {
            var dl = document.getElementById(dlId);
            if (dl) return dl;
            dl = document.createElement('datalist');
            dl.id = dlId;
            document.body.appendChild(dl);
            input.setAttribute('list', dlId);
            return dl;
        }

        function renderDatalist(dl, items) {
            while (dl.firstChild) dl.removeChild(dl.firstChild);
            (items || []).forEach(function (it) {
                var code = String(it.code_main || '').trim();
                var label = String(it.label_it || '').trim();
                if (!code) return;
                var opt = document.createElement('option');
                opt.value = code + (label ? ' — ' + label : '');
                dl.appendChild(opt);
            });
        }

        survey.onAfterRenderQuestion.add(function (sender, options) {
            var q = options && options.question ? options.question : null;
            var el = options && options.htmlElement ? options.htmlElement : null;
            if (!q || !el) return;
            // Only target CPV code questions inside the dynamic panel.
            if (q.name !== 'cpv_code') return;
            // SurveyJS may render multiple inputs (some hidden); prefer the visible text one.
            var input = el.querySelector('input[type="text"], input:not([type])');
            if (!input) input = el.querySelector('input');
            if (!input) return;
            if (input.dataset.vgCpvAttached === '1') return;
            input.dataset.vgCpvAttached = '1';

            var dlId = 'vg-cpv-dl-' + String(q.id || q.name || Math.random()).replace(/[^a-zA-Z0-9_-]/g, '');
            var dl = ensureDatalist(input, dlId);

            var pending = null;
            var lastItemsByCode = Object.create(null); // code -> label

            function setLabelValue(val) {
                // Prefer panel.setValue for dynamic panels; fall back to survey data.
                try {
                    if (q.panel && typeof q.panel.setValue === 'function') {
                        q.panel.setValue('cpv_label', val || '');
                    }
                } catch (e) {}
                // Also set the question value directly (ensures UI refresh for readOnly fields).
                try {
                    var panel = q.panel || null;
                    var lq = null;
                    if (panel && typeof panel.getQuestionByName === 'function') {
                        lq = panel.getQuestionByName('cpv_label');
                    }
                    if (!lq && panel && panel.elements && panel.elements.length) {
                        panel.elements.forEach(function (e2) {
                            if (e2 && e2.name === 'cpv_label') lq = e2;
                        });
                    }
                    if (lq) lq.value = val || '';
                } catch (e0) {}
                try {
                    // last resort: mutate panel data object
                    if (q.panel && q.panel.data) {
                        q.panel.data.cpv_label = val || '';
                    }
                } catch (e2) {}
            }

            function setLabelInputDom(val) {
                // Ultra-robust fallback: update the readonly input element in the same panel.
                try {
                    var panelRoot = el.closest('.sd-panel__content') || el.closest('.sd-paneldynamic__panel') || el.parentElement;
                    if (!panelRoot) return;
                    var labelHost = panelRoot.querySelector('[data-name="cpv_label"] input');
                    if (!labelHost) labelHost = panelRoot.querySelector('div[data-name="cpv_label"] input');
                    if (!labelHost) return;
                    labelHost.value = String(val || '');
                    // Trigger an input event so SurveyJS UI refreshes if it listens.
                    try {
                        labelHost.dispatchEvent(new Event('input', { bubbles: true }));
                        labelHost.dispatchEvent(new Event('change', { bubbles: true }));
                    } catch (e2) {}
                } catch (e) {}
            }

            function setLabel(val) {
                setLabelValue(val);
                setLabelInputDom(val);
            }

            function updateLabelFromRaw(raw) {
                var s = String(raw || '').trim();
                if (!s) {
                    // Clear label
                    setLabel('');
                    return;
                }
                var digits = s.replace(/\D/g, '').slice(0, 16);
                var label = '';
                if (digits && lastItemsByCode[digits]) {
                    label = lastItemsByCode[digits];
                } else {
                    // Try parse "CODE — LABEL" or "CODE - LABEL"
                    var m = /^\s*([0-9]{4,16})\s*(?:—|-)\s*(.+?)\s*$/.exec(s);
                    if (m) {
                        digits = String(m[1] || '').replace(/\D/g, '');
                        label = String(m[2] || '').trim();
                    } else {
                        // Fallback: split on em-dash if present
                        var parts = s.split('—');
                        if (parts.length >= 2) {
                            var pCode = String(parts[0] || '').replace(/\D/g, '');
                            var pLab = String(parts.slice(1).join('—') || '').trim();
                            if (pCode) digits = pCode;
                            if (pLab) label = pLab;
                        }
                    }
                }
                if (digits) {
                    // Normalize displayed value to digits only.
                    input.value = digits;
                    q.value = digits;
                }
                var finalLabel = label || (digits && lastItemsByCode[digits] ? lastItemsByCode[digits] : '');
                if (finalLabel) {
                    setLabel(finalLabel);
                    return;
                }
                // If we only have a code, resolve label via API (best-effort).
                if (digits) {
                    fetchSuggest(digits).then(function (items) {
                        var it0 = (items && items[0]) ? items[0] : null;
                        var lab = it0 && it0.label_it ? String(it0.label_it) : '';
                        if (lab) setLabel(lab);
                    });
                } else {
                    setLabel('');
                }
            }

            input.addEventListener('input', function () {
                var raw = String(input.value || '').trim();
                if (pending) window.clearTimeout(pending);
                // avoid spam: require at least 2 letters, or any digit
                if (raw.length < 2 && !/\d/.test(raw)) return;
                pending = window.setTimeout(function () {
                    fetchSuggest(raw).then(function (items) {
                        lastItemsByCode = Object.create(null);
                        (items || []).forEach(function (it) {
                            var code = String(it.code_main || '').trim();
                            var label = String(it.label_it || '').trim();
                            if (code) lastItemsByCode[code] = label;
                        });
                        renderDatalist(dl, items);
                    });
                }, 180);
                // If user picked an option like "CODE — LABEL" or "CODE - LABEL",
                // update immediately (don't wait for blur).
                if (/[—-]/.test(raw)) {
                    updateLabelFromRaw(raw);
                }
            });

            input.addEventListener('blur', function () {
                updateLabelFromRaw(input.value);
            });

            input.addEventListener('change', function () {
                updateLabelFromRaw(input.value);
            });
        });
    }

    // -----------------------------
    // Financial metrics autocomplete
    // -----------------------------

    var _vgMetricsIndexPromise = null;
    var _vgMetricsIndex = null; // array

    function metricsAssetUrl() {
        // Theme static asset (packed in the theme zip): /assets/metrics.json
        return '/assets/metrics.json';
    }

    async function loadMetricsIndex() {
        if (_vgMetricsIndex) return _vgMetricsIndex;
        if (_vgMetricsIndexPromise) return await _vgMetricsIndexPromise;
        _vgMetricsIndexPromise = fetch(metricsAssetUrl(), { headers: { Accept: 'application/json' } })
            .then(function (r) { if (!r.ok) throw r; return r.json(); })
            .then(function (arr) { _vgMetricsIndex = Array.isArray(arr) ? arr : []; return _vgMetricsIndex; })
            .catch(function () { _vgMetricsIndex = []; return _vgMetricsIndex; });
        return await _vgMetricsIndexPromise;
    }

    // ------------------------------------
    // Capabilities (SOA categories) index
    // ------------------------------------

    var _vgCapabilitiesIndexPromise = null;
    var _vgCapabilitiesIndex = null; // array

    function capabilitiesAssetUrl() {
        // Theme static asset (packed in the theme zip): /assets/capabilities.json
        return '/assets/capabilities.json';
    }

    async function loadCapabilitiesIndex() {
        if (_vgCapabilitiesIndex) return _vgCapabilitiesIndex;
        if (_vgCapabilitiesIndexPromise) return await _vgCapabilitiesIndexPromise;
        _vgCapabilitiesIndexPromise = fetch(capabilitiesAssetUrl(), { headers: { Accept: 'application/json' } })
            .then(function (r) { if (!r.ok) throw r; return r.json(); })
            .then(function (arr) { _vgCapabilitiesIndex = Array.isArray(arr) ? arr : []; return _vgCapabilitiesIndex; })
            .catch(function () { _vgCapabilitiesIndex = []; return _vgCapabilitiesIndex; });
        return await _vgCapabilitiesIndexPromise;
    }

    // -----------------------------
    // Certifications index
    // -----------------------------

    var _vgCertificationsIndexPromise = null;
    var _vgCertificationsIndex = null; // array

    function certificationsAssetUrl() {
        // Theme static asset (packed in the theme zip): /assets/certifications.json
        return '/assets/certifications.json';
    }

    async function loadCertificationsIndex() {
        if (_vgCertificationsIndex) return _vgCertificationsIndex;
        if (_vgCertificationsIndexPromise) return await _vgCertificationsIndexPromise;
        _vgCertificationsIndexPromise = fetch(certificationsAssetUrl(), { headers: { Accept: 'application/json' } })
            .then(function (r) { if (!r.ok) throw r; return r.json(); })
            .then(function (arr) { _vgCertificationsIndex = Array.isArray(arr) ? arr : []; return _vgCertificationsIndex; })
            .catch(function () { _vgCertificationsIndex = []; return _vgCertificationsIndex; });
        return await _vgCertificationsIndexPromise;
    }

    // -----------------------------
    // Languages index
    // -----------------------------

    var _vgLanguagesIndexPromise = null;
    var _vgLanguagesIndex = null; // array

    function languagesAssetUrl() {
        // Theme static asset (packed in the theme zip): /assets/languages.json
        return '/assets/languages.json';
    }

    async function loadLanguagesIndex() {
        if (_vgLanguagesIndex) return _vgLanguagesIndex;
        if (_vgLanguagesIndexPromise) return await _vgLanguagesIndexPromise;
        _vgLanguagesIndexPromise = fetch(languagesAssetUrl(), { headers: { Accept: 'application/json' } })
            .then(function (r) { if (!r.ok) throw r; return r.json(); })
            .then(function (arr) { _vgLanguagesIndex = Array.isArray(arr) ? arr : []; return _vgLanguagesIndex; })
            .catch(function () { _vgLanguagesIndex = []; return _vgLanguagesIndex; });
        return await _vgLanguagesIndexPromise;
    }

    // -----------------------------
    // Repair datalist bindings (SurveyJS page nav)
    // -----------------------------

    function ensureDatalistById(dlId) {
        if (!dlId) return null;
        var dl = document.getElementById(dlId);
        if (dl) return dl;
        dl = document.createElement('datalist');
        dl.id = dlId;
        document.body.appendChild(dl);
        return dl;
    }

    function repairAutocompleteBindings() {
        try {
            var mount = mountSurveyNode();
            if (!mount) return;
            var inputs = mount.querySelectorAll(
                'input[data-vg-cap-dl-id], input[data-vg-cert-dl-id], input[data-vg-lang-dl-id], input[data-vg-langlvl-dl-id]'
            );
            for (var i = 0; i < inputs.length; i++) {
                var inp = inputs[i];
                var dlId = inp.dataset.vgCapDlId || inp.dataset.vgCertDlId || inp.dataset.vgLangDlId || inp.dataset.vgLanglvlDlId || '';
                if (!dlId) continue;
                try { inp.setAttribute('list', dlId); } catch (e0) {}
                ensureDatalistById(dlId);
            }
        } catch (e) {}
    }

    function attachFinancialMetricsAutocomplete(survey) {
        function ensureDatalist(input, dlId) {
            var dl = document.getElementById(dlId);
            if (dl) return dl;
            dl = document.createElement('datalist');
            dl.id = dlId;
            document.body.appendChild(dl);
            input.setAttribute('list', dlId);
            return dl;
        }

        function renderDatalist(dl, items) {
            while (dl.firstChild) dl.removeChild(dl.firstChild);
            (items || []).forEach(function (m) {
                if (!m) return;
                var code = String(m.code || '').trim();
                var label = String(m.label || '').trim();
                if (!code) return;
                var opt = document.createElement('option');
                // Datalist "label" is inconsistently rendered across browsers.
                // Use a combined value so the dropdown is meaningful; normalizeCode() will extract CODE.
                opt.value = label ? (code + ' — ' + label) : code;
                dl.appendChild(opt);
            });
        }

        function normalizeCode(raw) {
            var s = String(raw || '').trim();
            if (!s) return '';
            // Accept either CODE or "CODE — label" pasted.
            var m = /^\s*([A-Z0-9_]+)\s*(?:—|-)\s*(.+?)\s*$/.exec(s);
            if (m && m[1]) return String(m[1]).trim();
            return s;
        }

        function unitToCurrencyMaybe(unit) {
            var u = String(unit || '').trim().toLowerCase();
            if (!u) return '';
            if (u.indexOf('eur') === 0) return 'EUR';
            return '';
        }

        function setPanelValueSafe(panel, key, val) {
            try {
                if (panel && typeof panel.setValue === 'function') {
                    panel.setValue(key, val);
                    return;
                }
            } catch (e) {}
            try {
                if (panel && panel.data) {
                    panel.data[key] = val;
                }
            } catch (e2) {}
        }

        function getPanelQuestion(panel, name) {
            try {
                if (panel && typeof panel.getQuestionByName === 'function') return panel.getQuestionByName(name);
            } catch (e) {}
            try {
                var found = null;
                if (panel && panel.elements && panel.elements.length) {
                    panel.elements.forEach(function (el) { if (el && el.name === name) found = el; });
                }
                return found;
            } catch (e2) {}
            return null;
        }

        function getLikelyPanel(q) {
            // SurveyJS internals differ by version/layout.
            // Try common links first; fallback to parent chain.
            try { if (q && q.panel) return q.panel; } catch (e) {}
            try { if (q && q.parent && (q.parent.elements || q.parent.getQuestionByName)) return q.parent; } catch (e2) {}
            try {
                var cur = q ? q.parent : null;
                var guard = 0;
                while (cur && guard++ < 8) {
                    if (cur.getQuestionByName || cur.elements) return cur;
                    cur = cur.parent || null;
                }
            } catch (e3) {}
            return null;
        }

        function setDomValueWithinPanel(htmlEl, qName, val) {
            try {
                var panelRoot = htmlEl.closest('.sd-paneldynamic__panel') || htmlEl.closest('.sd-panel__content') || htmlEl.parentElement;
                if (!panelRoot) return;
                var target = panelRoot.querySelector('[data-name="' + qName + '"] input');
                if (!target) target = panelRoot.querySelector('[data-name="' + qName + '"] textarea');
                if (!target) return;
                target.value = String(val == null ? '' : val);
                try {
                    target.dispatchEvent(new Event('input', { bubbles: true }));
                    target.dispatchEvent(new Event('change', { bubbles: true }));
                } catch (e2) {}
            } catch (e) {}
        }

        function findBestMatches(index, q) {
            var qs = String(q || '').trim().toLowerCase();
            if (!qs) return [];
            var out = [];
            for (var i = 0; i < index.length; i++) {
                var m = index[i];
                if (!m) continue;
                var code = String(m.code || '').toLowerCase();
                var label = String(m.label || '').toLowerCase();
                var desc = String(m.description || '').toLowerCase();
                if (code.indexOf(qs) !== -1 || label.indexOf(qs) !== -1 || desc.indexOf(qs) !== -1) {
                    out.push(m);
                    if (out.length >= 25) break;
                }
            }
            return out;
        }

        survey.onAfterRenderQuestion.add(function (sender, options) {
            var q = options && options.question ? options.question : null;
            var el = options && options.htmlElement ? options.htmlElement : null;
            if (!q || !el) return;
            if (q.name !== 'metric_code') return;
            // Attach inside the financial_metrics row. We used to rely on q.panel,
            // but some SurveyJS builds don't expose it reliably.
            var panel = getLikelyPanel(q);

            var input = el.querySelector('input[type="text"], input:not([type])');
            if (!input) input = el.querySelector('input');
            if (!input) return;
            if (input.dataset.vgMetricAttached === '1') return;
            input.dataset.vgMetricAttached = '1';
            try { input.setAttribute('autocomplete', 'off'); } catch (e0) {}

            var dlId = 'vg-metrics-dl-' + String(q.id || Math.random()).replace(/[^a-zA-Z0-9_-]/g, '');
            var dl = ensureDatalist(input, dlId);

            var pending = null;
            var lastIndex = null;
            var byCode = Object.create(null); // CODE -> metric

            function rebuildByCode(idx) {
                byCode = Object.create(null);
                (idx || []).forEach(function (m) {
                    var c = String(m && m.code ? m.code : '').trim();
                    if (!c) return;
                    byCode[c.toUpperCase()] = m;
                });
            }

            function applyMetricToPanel(metric) {
                if (!metric) return;
                var code = String(metric.code || '').trim();
                var label = String(metric.label || '').trim();
                var unit = String(metric.unit || '').trim();
                var desc = String(metric.description || '').trim();
                var why = String(metric.why_it_matters || '').trim();
                var category = String(metric.category || '').trim();
                var level = String(metric.level || '').trim();

                if (code) {
                    input.value = code;
                    q.value = code;
                    if (panel) setPanelValueSafe(panel, 'metric_code', code);
                }
                if (label) {
                    if (panel) setPanelValueSafe(panel, 'metric_label', label);
                    var qLab = panel ? getPanelQuestion(panel, 'metric_label') : null;
                    if (qLab) qLab.value = label;
                    setDomValueWithinPanel(el, 'metric_label', label);
                }

                var cur = unitToCurrencyMaybe(unit);
                if (cur) {
                    if (panel) setPanelValueSafe(panel, 'currency_code', cur);
                    var qCur = panel ? getPanelQuestion(panel, 'currency_code') : null;
                    if (qCur) qCur.value = cur;
                    setDomValueWithinPanel(el, 'currency_code', cur);
                }

                // Notes: if empty, prefill with a compact description (user can edit).
                try {
                    var qNotes = panel ? getPanelQuestion(panel, 'notes') : null;
                    var existing = qNotes ? String(qNotes.value || '').trim() : '';
                    if (!existing) {
                        var note = '';
                        if (unit) note += 'Unità: ' + unit + '. ';
                        if (desc) note += desc + ' ';
                        if (why) note += 'Perché conta: ' + why + ' ';
                        if (category || level) note += '(' + [category, level].filter(Boolean).join(', ') + ')';
                        note = note.trim();
                        if (note) {
                            setPanelValueSafe(panel, 'notes', note);
                            if (qNotes) qNotes.value = note;
                            setDomValueWithinPanel(el, 'notes', note);
                        }
                    }
                } catch (e) {}
            }

            function resolveAndApply(raw) {
                var code = normalizeCode(raw);
                if (!code) return;
                var m = byCode[String(code).toUpperCase()] || null;
                if (m) applyMetricToPanel(m);
            }

            input.addEventListener('input', function () {
                var raw = String(input.value || '').trim();
                if (pending) window.clearTimeout(pending);
                if (raw.length < 1) return;
                pending = window.setTimeout(function () {
                    loadMetricsIndex().then(function (idx) {
                        lastIndex = idx || [];
                        rebuildByCode(lastIndex);
                        var matches = findBestMatches(lastIndex, raw);
                        renderDatalist(dl, matches);
                        // If user typed a full code, apply immediately.
                        resolveAndApply(raw);
                    });
                }, 120);
            });
            input.addEventListener('focus', function () {
                loadMetricsIndex().then(function (idx) {
                    lastIndex = idx || [];
                    rebuildByCode(lastIndex);
                    var raw = String(input.value || '').trim();
                    var matches = raw ? findBestMatches(lastIndex, raw) : lastIndex.slice(0, 25);
                    renderDatalist(dl, matches);
                });
            });
            input.addEventListener('change', function () { resolveAndApply(input.value); });
            input.addEventListener('blur', function () { resolveAndApply(input.value); });

            // Warm the index once (best-effort).
            loadMetricsIndex().then(function (idx) {
                lastIndex = idx || [];
                rebuildByCode(lastIndex);
            });
        });
    }

    // -----------------------------
    // Capabilities autocomplete
    // -----------------------------

    function attachCapabilitiesAutocomplete(survey) {
        function ensureDatalist(input, dlId) {
            var dl = document.getElementById(dlId);
            if (dl) return dl;
            dl = document.createElement('datalist');
            dl.id = dlId;
            document.body.appendChild(dl);
            input.setAttribute('list', dlId);
            return dl;
        }

        function renderDatalist(dl, items) {
            while (dl.firstChild) dl.removeChild(dl.firstChild);
            (items || []).forEach(function (c) {
                if (!c) return;
                var code = String(c.code || '').trim();
                var label = String(c.label || '').trim();
                if (!code) return;
                var opt = document.createElement('option');
                opt.value = label ? (code + ' — ' + label) : code;
                dl.appendChild(opt);
            });
        }

        function normalizeCode(raw) {
            var s = String(raw || '').trim();
            if (!s) return '';
            var m = /^\s*([A-Z0-9]+)\s*(?:—|-)\s*(.+?)\s*$/.exec(s);
            if (m && m[1]) return String(m[1]).trim();
            return s;
        }

        function setPanelValueSafe(panel, key, val) {
            try {
                if (panel && typeof panel.setValue === 'function') {
                    panel.setValue(key, val);
                    return;
                }
            } catch (e) {}
            try {
                if (panel && panel.data) {
                    panel.data[key] = val;
                }
            } catch (e2) {}
        }

        function getPanelQuestion(panel, name) {
            try {
                if (panel && typeof panel.getQuestionByName === 'function') return panel.getQuestionByName(name);
            } catch (e) {}
            try {
                var found = null;
                if (panel && panel.elements && panel.elements.length) {
                    panel.elements.forEach(function (el) { if (el && el.name === name) found = el; });
                }
                return found;
            } catch (e2) {}
            return null;
        }

        function getLikelyPanel(q) {
            try { if (q && q.panel) return q.panel; } catch (e) {}
            try { if (q && q.parent && (q.parent.elements || q.parent.getQuestionByName)) return q.parent; } catch (e2) {}
            try {
                var cur = q ? q.parent : null;
                var guard = 0;
                while (cur && guard++ < 8) {
                    if (cur.getQuestionByName || cur.elements) return cur;
                    cur = cur.parent || null;
                }
            } catch (e3) {}
            return null;
        }

        function setDomValueWithinPanel(htmlEl, qName, val) {
            try {
                var panelRoot = htmlEl.closest('.sd-paneldynamic__panel') || htmlEl.closest('.sd-panel__content') || htmlEl.parentElement;
                if (!panelRoot) return;
                var target = panelRoot.querySelector('[data-name="' + qName + '"] input');
                if (!target) target = panelRoot.querySelector('[data-name="' + qName + '"] textarea');
                if (!target) return;
                target.value = String(val == null ? '' : val);
                try {
                    target.dispatchEvent(new Event('input', { bubbles: true }));
                    target.dispatchEvent(new Event('change', { bubbles: true }));
                } catch (e2) {}
            } catch (e) {}
        }

        function findBestMatches(index, q) {
            var qs = String(q || '').trim().toLowerCase();
            if (!qs) return [];
            var out = [];
            for (var i = 0; i < index.length; i++) {
                var it = index[i];
                if (!it) continue;
                var code = String(it.code || '').toLowerCase();
                var label = String(it.label || '').toLowerCase();
                if (code.indexOf(qs) !== -1 || label.indexOf(qs) !== -1) {
                    out.push(it);
                    if (out.length >= 25) break;
                }
            }
            return out;
        }

        survey.onAfterRenderQuestion.add(function (sender, options) {
            var q = options && options.question ? options.question : null;
            var el = options && options.htmlElement ? options.htmlElement : null;
            if (!q || !el) return;
            if (q.name !== 'capability_code') return;

            var panel = getLikelyPanel(q);
            var input = el.querySelector('input[type="text"], input:not([type])');
            if (!input) input = el.querySelector('input');
            if (!input) return;
            var dlId = 'vg-cap-dl-' + String(q.id || Math.random()).replace(/[^a-zA-Z0-9_-]/g, '');
            // If already attached (SurveyJS can reuse nodes across page navigation),
            // ensure the datalist binding is still present.
            if (input.dataset.vgCapAttached === '1') {
                var prev = input.dataset.vgCapDlId || '';
                var useId = prev || dlId;
                input.dataset.vgCapDlId = useId;
                try { input.setAttribute('list', useId); } catch (e0a) {}
                ensureDatalist(input, useId);
                return;
            }
            input.dataset.vgCapAttached = '1';
            input.dataset.vgCapDlId = dlId;
            try { input.setAttribute('autocomplete', 'off'); } catch (e0) {}

            var dl = ensureDatalist(input, dlId);

            var pending = null;
            var lastIndex = null;
            var byCode = Object.create(null); // CODE -> item

            function rebuildByCode(idx) {
                byCode = Object.create(null);
                (idx || []).forEach(function (it) {
                    var c = String(it && it.code ? it.code : '').trim();
                    if (!c) return;
                    byCode[c.toUpperCase()] = it;
                });
            }

            function applyCapabilityToPanel(it) {
                if (!it) return;
                var code = String(it.code || '').trim();
                var label = String(it.label || '').trim();
                if (code) {
                    input.value = code;
                    q.value = code;
                    if (panel) setPanelValueSafe(panel, 'capability_code', code);
                }
                if (label) {
                    if (panel) setPanelValueSafe(panel, 'capability_label', label);
                    var qLab = panel ? getPanelQuestion(panel, 'capability_label') : null;
                    if (qLab) qLab.value = label;
                    setDomValueWithinPanel(el, 'capability_label', label);
                }
                // If empty, prefill "Tipo" with SOA (user can still edit).
                try {
                    var qType = panel ? getPanelQuestion(panel, 'capability_type') : null;
                    var existing = qType ? String(qType.value || '').trim() : '';
                    if (!existing) {
                        if (panel) setPanelValueSafe(panel, 'capability_type', 'SOA');
                        if (qType) qType.value = 'SOA';
                        setDomValueWithinPanel(el, 'capability_type', 'SOA');
                    }
                } catch (e2) {}
            }

            function resolveAndApply(raw) {
                var code = normalizeCode(raw);
                if (!code) return;
                var it = byCode[String(code).toUpperCase()] || null;
                if (it) applyCapabilityToPanel(it);
            }

            input.addEventListener('input', function () {
                var raw = String(input.value || '').trim();
                if (pending) window.clearTimeout(pending);
                if (raw.length < 1) return;
                pending = window.setTimeout(function () {
                    loadCapabilitiesIndex().then(function (idx) {
                        lastIndex = idx || [];
                        rebuildByCode(lastIndex);
                        var matches = findBestMatches(lastIndex, raw);
                        renderDatalist(dl, matches);
                        // If user typed a full code, apply immediately.
                        resolveAndApply(raw);
                    });
                }, 120);
            });
            input.addEventListener('focus', function () {
                loadCapabilitiesIndex().then(function (idx) {
                    lastIndex = idx || [];
                    rebuildByCode(lastIndex);
                    var raw = String(input.value || '').trim();
                    var matches = raw ? findBestMatches(lastIndex, raw) : lastIndex.slice(0, 25);
                    renderDatalist(dl, matches);
                });
            });
            input.addEventListener('change', function () { resolveAndApply(input.value); });
            input.addEventListener('blur', function () { resolveAndApply(input.value); });

            loadCapabilitiesIndex().then(function (idx) {
                lastIndex = idx || [];
                rebuildByCode(lastIndex);
            });
        });
    }

    // -----------------------------
    // Certifications autocomplete
    // -----------------------------

    function attachCertificationsAutocomplete(survey) {
        function ensureDatalist(input, dlId) {
            var dl = document.getElementById(dlId);
            if (dl) return dl;
            dl = document.createElement('datalist');
            dl.id = dlId;
            document.body.appendChild(dl);
            input.setAttribute('list', dlId);
            return dl;
        }

        function renderDatalist(dl, items) {
            while (dl.firstChild) dl.removeChild(dl.firstChild);
            (items || []).forEach(function (c) {
                if (!c) return;
                var code = String(c.code || '').trim();
                var label = String(c.label || '').trim();
                if (!code) return;
                var opt = document.createElement('option');
                opt.value = label ? (code + ' — ' + label) : code;
                dl.appendChild(opt);
            });
        }

        function normalizeCode(raw) {
            var s = String(raw || '').trim();
            if (!s) return '';
            var m = /^\s*([A-Z0-9./\-\s]+)\s*(?:—|-)\s*(.+?)\s*$/.exec(s);
            if (m && m[1]) return String(m[1]).trim();
            return s;
        }

        function setPanelValueSafe(panel, key, val) {
            try {
                if (panel && typeof panel.setValue === 'function') {
                    panel.setValue(key, val);
                    return;
                }
            } catch (e) {}
            try {
                if (panel && panel.data) {
                    panel.data[key] = val;
                }
            } catch (e2) {}
        }

        function getPanelQuestion(panel, name) {
            try {
                if (panel && typeof panel.getQuestionByName === 'function') return panel.getQuestionByName(name);
            } catch (e) {}
            try {
                var found = null;
                if (panel && panel.elements && panel.elements.length) {
                    panel.elements.forEach(function (el) { if (el && el.name === name) found = el; });
                }
                return found;
            } catch (e2) {}
            return null;
        }

        function getLikelyPanel(q) {
            try { if (q && q.panel) return q.panel; } catch (e) {}
            try { if (q && q.parent && (q.parent.elements || q.parent.getQuestionByName)) return q.parent; } catch (e2) {}
            try {
                var cur = q ? q.parent : null;
                var guard = 0;
                while (cur && guard++ < 8) {
                    if (cur.getQuestionByName || cur.elements) return cur;
                    cur = cur.parent || null;
                }
            } catch (e3) {}
            return null;
        }

        function setDomValueWithinPanel(htmlEl, qName, val) {
            try {
                var panelRoot = htmlEl.closest('.sd-paneldynamic__panel') || htmlEl.closest('.sd-panel__content') || htmlEl.parentElement;
                if (!panelRoot) return;
                var target = panelRoot.querySelector('[data-name="' + qName + '"] input');
                if (!target) target = panelRoot.querySelector('[data-name="' + qName + '"] textarea');
                if (!target) return;
                target.value = String(val == null ? '' : val);
                try {
                    target.dispatchEvent(new Event('input', { bubbles: true }));
                    target.dispatchEvent(new Event('change', { bubbles: true }));
                } catch (e2) {}
            } catch (e) {}
        }

        function findBestMatches(index, q) {
            var qs = String(q || '').trim().toLowerCase();
            if (!qs) return [];
            function compact(s) {
                return String(s || '')
                    .toLowerCase()
                    .replace(/[\s\/\\\-\._:]+/g, '');
            }
            var qc = compact(qs);
            // Also allow searching ISO/IEC refs as if they were plain ISO.
            // Example: "ISO/IEC 27001" -> "isoiec27001" and "iso27001"
            function isoAlias(s) {
                var t = String(s || '');
                if (!t) return '';
                // If it begins with isoiec..., treat it as iso...
                // This makes "iso27" match "ISO/IEC 27001" (compacted to isoiec27001).
                if (t.indexOf('isoiec') === 0) return 'iso' + t.slice(6);
                return t;
            }
            var out = [];
            for (var i = 0; i < index.length; i++) {
                var it = index[i];
                if (!it) continue;
                var code = String(it.code || '').toLowerCase();
                var label = String(it.label || '').toLowerCase();
                var desc = String(it.description || '').toLowerCase();
                var cat = String(it.category || '').toLowerCase();

                // Also match on a compact form so "iso27001" matches "ISO/IEC 27001".
                var codeC = compact(code);
                var labelC = compact(label);
                var descC = compact(desc);
                var catC = compact(cat);
                var codeA = isoAlias(codeC);
                var labelA = isoAlias(labelC);
                var descA = isoAlias(descC);
                var catA = isoAlias(catC);

                if (
                    code.indexOf(qs) !== -1 ||
                    label.indexOf(qs) !== -1 ||
                    desc.indexOf(qs) !== -1 ||
                    cat.indexOf(qs) !== -1 ||
                    (qc &&
                        (codeC.indexOf(qc) !== -1 ||
                            labelC.indexOf(qc) !== -1 ||
                            descC.indexOf(qc) !== -1 ||
                            catC.indexOf(qc) !== -1 ||
                            codeA.indexOf(qc) !== -1 ||
                            labelA.indexOf(qc) !== -1 ||
                            descA.indexOf(qc) !== -1 ||
                            catA.indexOf(qc) !== -1))
                ) {
                    out.push(it);
                    if (out.length >= 25) break;
                }
            }
            return out;
        }

        survey.onAfterRenderQuestion.add(function (sender, options) {
            var q = options && options.question ? options.question : null;
            var el = options && options.htmlElement ? options.htmlElement : null;
            if (!q || !el) return;
            if (q.name !== 'certification_name') return;

            var panel = getLikelyPanel(q);
            var input = el.querySelector('input[type="text"], input:not([type])');
            if (!input) input = el.querySelector('input');
            if (!input) return;
            var dlId = 'vg-cert-dl-' + String(q.id || Math.random()).replace(/[^a-zA-Z0-9_-]/g, '');
            // If already attached (SurveyJS can reuse nodes across page navigation),
            // ensure the datalist binding is still present.
            if (input.dataset.vgCertAttached === '1') {
                var prev = input.dataset.vgCertDlId || '';
                var useId = prev || dlId;
                input.dataset.vgCertDlId = useId;
                try { input.setAttribute('list', useId); } catch (e0a) {}
                ensureDatalist(input, useId);
                return;
            }
            input.dataset.vgCertAttached = '1';
            input.dataset.vgCertDlId = dlId;
            try { input.setAttribute('autocomplete', 'off'); } catch (e0) {}

            var dl = ensureDatalist(input, dlId);

            var pending = null;
            var lastIndex = null;
            var byCode = Object.create(null);

            function rebuildByCode(idx) {
                byCode = Object.create(null);
                (idx || []).forEach(function (it) {
                    var c = String(it && it.code ? it.code : '').trim();
                    if (!c) return;
                    byCode[c.toUpperCase()] = it;
                });
            }

            function applyCertificationToPanel(it) {
                if (!it) return;
                var code = String(it.code || '').trim();
                var label = String(it.label || '').trim();
                var desc = String(it.description || '').trim();
                var cat = String(it.category || '').trim();

                if (code) {
                    input.value = code;
                    q.value = code;
                    if (panel) setPanelValueSafe(panel, 'certification_name', code);
                }

                // Notes: if empty, prefill with a compact description (user can edit).
                try {
                    var qNotes = panel ? getPanelQuestion(panel, 'notes') : null;
                    var existing = qNotes ? String(qNotes.value || '').trim() : '';
                    if (!existing) {
                        var note = '';
                        if (label) note += label.trim() + ' ';
                        if (cat) note += '(' + cat + '). ';
                        if (desc) note += desc;
                        note = note.trim();
                        if (note) {
                            if (panel) setPanelValueSafe(panel, 'notes', note);
                            if (qNotes) qNotes.value = note;
                            setDomValueWithinPanel(el, 'notes', note);
                        }
                    }
                } catch (e2) {}
            }

            function resolveAndApply(raw) {
                var code = normalizeCode(raw);
                if (!code) return;
                var it = byCode[String(code).toUpperCase()] || null;
                if (it) applyCertificationToPanel(it);
            }

            input.addEventListener('input', function () {
                var raw = String(input.value || '').trim();
                if (pending) window.clearTimeout(pending);
                if (raw.length < 1) return;
                pending = window.setTimeout(function () {
                    loadCertificationsIndex().then(function (idx) {
                        lastIndex = idx || [];
                        rebuildByCode(lastIndex);
                        var matches = findBestMatches(lastIndex, raw);
                        renderDatalist(dl, matches);
                        resolveAndApply(raw);
                    });
                }, 120);
            });
            input.addEventListener('focus', function () {
                loadCertificationsIndex().then(function (idx) {
                    lastIndex = idx || [];
                    rebuildByCode(lastIndex);
                    var raw = String(input.value || '').trim();
                    var matches = raw ? findBestMatches(lastIndex, raw) : lastIndex.slice(0, 25);
                    renderDatalist(dl, matches);
                });
            });
            input.addEventListener('change', function () { resolveAndApply(input.value); });
            input.addEventListener('blur', function () { resolveAndApply(input.value); });

            loadCertificationsIndex().then(function (idx) {
                lastIndex = idx || [];
                rebuildByCode(lastIndex);
            });
        });
    }

    // -----------------------------
    // Languages autocomplete
    // -----------------------------

    function attachLanguagesAutocomplete(survey) {
        function ensureDatalist(input, dlId) {
            var dl = document.getElementById(dlId);
            if (dl) return dl;
            dl = document.createElement('datalist');
            dl.id = dlId;
            document.body.appendChild(dl);
            input.setAttribute('list', dlId);
            return dl;
        }

        function renderDatalist(dl, items) {
            while (dl.firstChild) dl.removeChild(dl.firstChild);
            (items || []).forEach(function (it) {
                if (!it) return;
                var code = String(it.code || '').trim();
                var label = String(it.label || '').trim();
                if (!code) return;
                var opt = document.createElement('option');
                opt.value = label ? (code + ' — ' + label) : code;
                dl.appendChild(opt);
            });
        }

        function normalizeCode(raw) {
            var s = String(raw || '').trim();
            if (!s) return '';
            var m = /^\s*([a-z]{2,3})\s*(?:—|-)\s*(.+?)\s*$/i.exec(s);
            if (m && m[1]) return String(m[1]).trim().toLowerCase();
            return s.toLowerCase();
        }

        function compact(s) {
            return String(s || '').toLowerCase().replace(/[\s\/\\\-\._:]+/g, '');
        }

        function getLikelyPanel(q) {
            try { if (q && q.panel) return q.panel; } catch (e) {}
            try { if (q && q.parent && (q.parent.elements || q.parent.getQuestionByName)) return q.parent; } catch (e2) {}
            try {
                var cur = q ? q.parent : null;
                var guard = 0;
                while (cur && guard++ < 8) {
                    if (cur.getQuestionByName || cur.elements) return cur;
                    cur = cur.parent || null;
                }
            } catch (e3) {}
            return null;
        }

        function getPanelQuestion(panel, name) {
            try {
                if (panel && typeof panel.getQuestionByName === 'function') return panel.getQuestionByName(name);
            } catch (e) {}
            try {
                var found = null;
                if (panel && panel.elements && panel.elements.length) {
                    panel.elements.forEach(function (el) { if (el && el.name === name) found = el; });
                }
                return found;
            } catch (e2) {}
            return null;
        }

        function setPanelValueSafe(panel, key, val) {
            try {
                if (panel && typeof panel.setValue === 'function') {
                    panel.setValue(key, val);
                    return;
                }
            } catch (e) {}
            try {
                if (panel && panel.data) {
                    panel.data[key] = val;
                }
            } catch (e2) {}
        }

        function setDomValueWithinPanel(htmlEl, qName, val) {
            try {
                var panelRoot = htmlEl.closest('.sd-paneldynamic__panel') || htmlEl.closest('.sd-panel__content') || htmlEl.parentElement;
                if (!panelRoot) return;
                var target = panelRoot.querySelector('[data-name="' + qName + '"] input');
                if (!target) target = panelRoot.querySelector('[data-name="' + qName + '"] textarea');
                if (!target) return;
                target.value = String(val == null ? '' : val);
                try {
                    target.dispatchEvent(new Event('input', { bubbles: true }));
                    target.dispatchEvent(new Event('change', { bubbles: true }));
                } catch (e2) {}
            } catch (e) {}
        }

        function findBestMatches(index, q) {
            var qs = String(q || '').trim().toLowerCase();
            if (!qs) return [];
            var qc = compact(qs);
            var out = [];
            for (var i = 0; i < index.length; i++) {
                var it = index[i];
                if (!it) continue;
                var code = String(it.code || '').toLowerCase();
                var label = String(it.label || '').toLowerCase();
                var codeC = compact(code);
                var labelC = compact(label);
                if (code.indexOf(qs) !== -1 || label.indexOf(qs) !== -1 || (qc && (codeC.indexOf(qc) !== -1 || labelC.indexOf(qc) !== -1))) {
                    out.push(it);
                    if (out.length >= 25) break;
                }
            }
            return out;
        }

        var PROF_LEVELS = [
            { code: 'A1', label: 'A1 (Base)' },
            { code: 'A2', label: 'A2 (Base)' },
            { code: 'B1', label: 'B1 (Intermedio)' },
            { code: 'B2', label: 'B2 (Intermedio avanzato)' },
            { code: 'C1', label: 'C1 (Avanzato)' },
            { code: 'C2', label: 'C2 (Padronanza)' },
            { code: 'Madrelingua', label: 'Madrelingua' },
            { code: 'Bilingue', label: 'Bilingue' },
            { code: 'Professionale', label: 'Professionale' }
        ];

        function findLevelMatches(q) {
            var qs = String(q || '').trim().toLowerCase();
            if (!qs) return PROF_LEVELS.slice(0, 25);
            var qc = compact(qs);
            return PROF_LEVELS.filter(function (x) {
                var c = String(x.code || '').toLowerCase();
                var l = String(x.label || '').toLowerCase();
                return c.indexOf(qs) !== -1 || l.indexOf(qs) !== -1 || compact(c).indexOf(qc) !== -1 || compact(l).indexOf(qc) !== -1;
            }).slice(0, 25);
        }

        // Language code (ISO 639-1)
        survey.onAfterRenderQuestion.add(function (sender, options) {
            var q = options && options.question ? options.question : null;
            var el = options && options.htmlElement ? options.htmlElement : null;
            if (!q || !el) return;
            if (q.name !== 'language_code') return;

            var panel = getLikelyPanel(q);
            var input = el.querySelector('input[type="text"], input:not([type])');
            if (!input) input = el.querySelector('input');
            if (!input) return;

            var dlId = 'vg-lang-dl-' + String(q.id || Math.random()).replace(/[^a-zA-Z0-9_-]/g, '');
            if (input.dataset.vgLangAttached === '1') {
                var prev = input.dataset.vgLangDlId || '';
                var useId = prev || dlId;
                input.dataset.vgLangDlId = useId;
                try { input.setAttribute('list', useId); } catch (e0a) {}
                ensureDatalist(input, useId);
                return;
            }
            input.dataset.vgLangAttached = '1';
            input.dataset.vgLangDlId = dlId;
            try { input.setAttribute('autocomplete', 'off'); } catch (e0) {}

            var dl = ensureDatalist(input, dlId);

            var pending = null;
            var lastIndex = null;
            var byCode = Object.create(null);

            function rebuildByCode(idx) {
                byCode = Object.create(null);
                (idx || []).forEach(function (it) {
                    var c = String(it && it.code ? it.code : '').trim();
                    if (!c) return;
                    byCode[c.toLowerCase()] = it;
                });
            }

            function applyLanguage(it) {
                if (!it) return;
                var code = String(it.code || '').trim().toLowerCase();
                var label = String(it.label || '').trim();
                if (code) {
                    input.value = code;
                    q.value = code;
                    if (panel) setPanelValueSafe(panel, 'language_code', code);
                }
                // If notes empty, set a simple label hint (optional).
                try {
                    var qNotes = panel ? getPanelQuestion(panel, 'notes') : null;
                    var existing = qNotes ? String(qNotes.value || '').trim() : '';
                    if (!existing && label) {
                        if (panel) setPanelValueSafe(panel, 'notes', label);
                        if (qNotes) qNotes.value = label;
                        setDomValueWithinPanel(el, 'notes', label);
                    }
                } catch (e2) {}
            }

            function resolveAndApply(raw) {
                var code = normalizeCode(raw);
                if (!code) return;
                var it = byCode[code] || null;
                if (it) applyLanguage(it);
            }

            input.addEventListener('input', function () {
                var raw = String(input.value || '').trim();
                if (pending) window.clearTimeout(pending);
                if (raw.length < 1) return;
                pending = window.setTimeout(function () {
                    loadLanguagesIndex().then(function (idx) {
                        lastIndex = idx || [];
                        rebuildByCode(lastIndex);
                        var matches = findBestMatches(lastIndex, raw);
                        renderDatalist(dl, matches);
                        resolveAndApply(raw);
                    });
                }, 120);
            });
            input.addEventListener('focus', function () {
                loadLanguagesIndex().then(function (idx) {
                    lastIndex = idx || [];
                    rebuildByCode(lastIndex);
                    var raw = String(input.value || '').trim();
                    var matches = raw ? findBestMatches(lastIndex, raw) : lastIndex.slice(0, 25);
                    renderDatalist(dl, matches);
                });
            });
            input.addEventListener('change', function () { resolveAndApply(input.value); });
            input.addEventListener('blur', function () { resolveAndApply(input.value); });

            loadLanguagesIndex().then(function (idx) {
                lastIndex = idx || [];
                rebuildByCode(lastIndex);
            });
        });

        // Proficiency label
        survey.onAfterRenderQuestion.add(function (sender, options) {
            var q = options && options.question ? options.question : null;
            var el = options && options.htmlElement ? options.htmlElement : null;
            if (!q || !el) return;
            if (q.name !== 'proficiency_label') return;

            var panel = getLikelyPanel(q);
            var input = el.querySelector('input[type="text"], input:not([type])');
            if (!input) input = el.querySelector('input');
            if (!input) return;

            var dlId = 'vg-langlvl-dl-' + String(q.id || Math.random()).replace(/[^a-zA-Z0-9_-]/g, '');
            if (input.dataset.vgLanglvlAttached === '1') {
                var prev = input.dataset.vgLanglvlDlId || '';
                var useId = prev || dlId;
                input.dataset.vgLanglvlDlId = useId;
                try { input.setAttribute('list', useId); } catch (e0a) {}
                ensureDatalist(input, useId);
                return;
            }
            input.dataset.vgLanglvlAttached = '1';
            input.dataset.vgLanglvlDlId = dlId;
            try { input.setAttribute('autocomplete', 'off'); } catch (e0) {}

            var dl = ensureDatalist(input, dlId);

            var pending = null;
            function resolveAndApply(raw) {
                var s = String(raw || '').trim();
                if (!s) return;
                // Don't force: allow free text.
                q.value = s;
                if (panel) setPanelValueSafe(panel, 'proficiency_label', s);
            }

            input.addEventListener('input', function () {
                var raw = String(input.value || '').trim();
                if (pending) window.clearTimeout(pending);
                pending = window.setTimeout(function () {
                    renderDatalist(dl, findLevelMatches(raw));
                }, 80);
            });
            input.addEventListener('focus', function () {
                renderDatalist(dl, findLevelMatches(input.value));
            });
            input.addEventListener('change', function () { resolveAndApply(input.value); });
            input.addEventListener('blur', function () { resolveAndApply(input.value); });
        });
    }

    async function listMyProfiles() {
        return await apiJson('/company-profiles?limit=1&offset=0');
    }

    async function createProfileMin(orgName) {
        return await apiJson('/company-profiles', {
            method: 'POST',
            jsonBody: { organization_name: String(orgName || '').trim() }
        });
    }

    async function patchProfile(profileId, patch) {
        return await apiJson('/company-profiles/' + encodeURIComponent(profileId), {
            method: 'PATCH',
            jsonBody: patch || {}
        });
    }

    async function getBundle(profileId) {
        return await apiJson('/company-profiles/' + encodeURIComponent(profileId) + '/bundle');
    }

    var _ragPollTimer = null;

    var RAG_STATUS_LABELS = {
        missing: 'Non indicizzato',
        pending: 'In coda',
        indexing: 'Indicizzazione…',
        ready: 'Pronto',
        failed: 'Errore'
    };

    var RAG_SOURCE_LABELS = {
        profile_core: 'Dati azienda',
        contact: 'Contatti',
        declaration: 'Dichiarazioni',
        cpv: 'CPV',
        certification: 'Certificazioni',
        reference: 'Referenze',
        territory: 'Territori',
        language: 'Lingue',
        financial_metric: 'Dati economici',
        capability: 'Capacità',
        attachment: 'Allegati',
        extra_json: 'Extra'
    };

    function ragPanelEl() {
        return document.getElementById('company-profile-rag-status') || qs('[data-cp-rag-panel]', root);
    }

    async function fetchRagStatus(profileId) {
        return await apiJson('/company-profiles/' + encodeURIComponent(profileId) + '/rag-status');
    }

    function renderRagStatusPanel(data) {
        var panel = ragPanelEl();
        if (!panel) return;
        if (!data) {
            panel.hidden = true;
            return;
        }
        panel.hidden = false;
        var st = String(data.status || 'missing');
        var badge = qs('[data-cp-rag-badge]', panel);
        var summary = qs('[data-cp-rag-summary]', panel);
        var notice = qs('[data-cp-rag-notice]', panel);
        var sources = qs('[data-cp-rag-sources]', panel);
        var meta = qs('[data-cp-rag-meta]', panel);
        if (badge) {
            badge.textContent = RAG_STATUS_LABELS[st] || st;
            badge.className = 'vg-cp-rag-status__badge vg-cp-rag-status__badge--' + st;
        }
        if (summary) {
            var cc = typeof data.chunk_count === 'number' ? data.chunk_count : 0;
            var when = data.indexed_at ? fmtDate(data.indexed_at) : '—';
            summary.textContent = cc + ' segmenti · agg. ' + when;
        }
        if (notice) {
            var n = String(data.notice || '').trim();
            if (n) {
                notice.textContent = n;
                notice.hidden = false;
            } else {
                notice.textContent = '';
                notice.hidden = true;
            }
        }
        if (sources) {
            var src = data.sources && typeof data.sources === 'object' ? data.sources : {};
            var bits = [];
            Object.keys(src).sort().forEach(function (k) {
                bits.push((RAG_SOURCE_LABELS[k] || k) + ' ' + src[k]);
            });
            if (bits.length && data.complete) {
                sources.textContent = bits.join(' · ');
                sources.hidden = false;
            } else {
                sources.textContent = '';
                sources.hidden = true;
            }
        }
        if (meta) {
            var parts = [];
            if (data.stale) parts.push('Profilo aggiornato: reindicizzazione in corso.');
            if (data.attachments_pending_text > 0) {
                parts.push(data.attachments_pending_text + ' allegati senza testo OCR.');
            }
            if (data.last_error) parts.push(String(data.last_error).slice(0, 120));
            if (parts.length) {
                meta.textContent = parts.join(' ');
                meta.hidden = false;
            } else {
                meta.textContent = '';
                meta.hidden = true;
            }
        }
        panel.classList.toggle('vg-cp-rag-status--incomplete', !data.complete);
    }

    function stopRagPolling() {
        if (_ragPollTimer) {
            window.clearInterval(_ragPollTimer);
            _ragPollTimer = null;
        }
    }

    function startRagPolling(profileId) {
        stopRagPolling();
        _ragPollTimer = window.setInterval(function () {
            fetchRagStatus(profileId).then(function (d) {
                renderRagStatusPanel(d);
                if (d && d.complete && !(d.job && (d.job.status === 'queued' || d.job.status === 'processing'))) {
                    stopRagPolling();
                }
            }).catch(function () {});
        }, 7000);
    }

    async function refreshRagStatus(profileId) {
        if (!profileId) {
            renderRagStatusPanel(null);
            stopRagPolling();
            return;
        }
        try {
            var data = await fetchRagStatus(profileId);
            renderRagStatusPanel(data);
            var jobSt = data && data.job ? String(data.job.status || '') : '';
            var needsPoll = !data.complete || jobSt === 'queued' || jobSt === 'processing'
                || data.status === 'pending' || data.status === 'indexing';
            if (needsPoll) startRagPolling(profileId);
            else stopRagPolling();
        } catch (e) {
            renderRagStatusPanel(null);
        }
    }

    function mountSurveyNode() {
        return document.getElementById('company-profile-survey') || qs('#company-profile-survey', root);
    }

    function mountFilesNode() {
        return document.getElementById('company-profile-files') || qs('#company-profile-files', root);
    }

    function ensureSurveyAvailable() {
        if (!window.Survey || !window.Survey.Model) {
            throw new Error('SurveyJS non caricato (bundle casper.js).');
        }
    }

    /** Data odierna in formato ISO (YYYY-MM-DD) per input type=date. */
    function cpTodayIsoDate() {
        var d = new Date();
        var y = d.getFullYear();
        var m = d.getMonth() + 1;
        var day = d.getDate();
        return y + '-' + String(m).padStart(2, '0') + '-' + String(day).padStart(2, '0');
    }

    function surveyJson() {
        var birthDateMax = cpTodayIsoDate();
        return {
            css: {
                root: 'sv_root sv_default_css',
                navigation: { complete: 'appaltimap-btn appaltimap-btn--primary', next: 'appaltimap-btn appaltimap-btn--primary', prev: 'appaltimap-btn' }
            },
            // Validate as the user fills the form (shows errors immediately).
            // With textUpdateMode "onBlur", most validations effectively run when the user leaves a text field.
            checkErrorsMode: 'onValueChanged',
            textUpdateMode: 'onBlur',
            showProgressBar: 'top',
            progressBarType: 'pages',
            progressBarShowPageTitles: true,
            progressBarShowPageNumbers: false,
            completedHtml: '<h3>Profilo salvato</h3>',
            pageNextText: 'Avanti',
            pagePrevText: 'Indietro',
            completeText: 'Fine',
            pages: [
                {
                    name: 'anagrafica',
                    title: 'Anagrafica azienda',
                    navigationTitle: 'Anagrafica',
                    elements: [
                        { type: 'text', name: 'organization_name', title: 'Ragione sociale', isRequired: true, width: '100%' },
                        {
                            type: 'text',
                            name: 'legal_form',
                            title: 'Forma giuridica',
                            startWithNewLine: false,
                            width: '50%',
                            placeholder: 'Es. SRL, SPA, Ditta individuale…',
                            dataList: [
                                'Ditta individuale',
                                'Impresa individuale',
                                'Libero professionista',
                                'Società semplice (SS)',
                                'Società in nome collettivo (SNC)',
                                'Società in accomandita semplice (SAS)',
                                'Società a responsabilità limitata (SRL)',
                                'Società a responsabilità limitata semplificata (SRLS)',
                                'Società per azioni (SPA)',
                                'Società in accomandita per azioni (SAPA)',
                                'Società cooperativa',
                                'Cooperativa sociale',
                                'Consorzio',
                                'Società consortile',
                                'Rete di imprese',
                                'Associazione',
                                'Fondazione',
                                'Ente del Terzo Settore (ETS)',
                                'Ente pubblico',
                                'Pubblica amministrazione',
                                'Università / Ente di ricerca',
                                'Azienda speciale / Consorzio pubblico',
                                'Start-up innovativa',
                                'PMI innovativa'
                            ]
                        },
                        { type: 'text', name: 'vat_number', title: 'Partita IVA', startWithNewLine: true, width: '50%', validators: [{ type: 'regex', text: 'Inserisci una P.IVA valida (11 cifre).', regex: '^\\d{11}$' }] },
                        { type: 'text', name: 'tax_code', title: 'Codice fiscale', startWithNewLine: false, width: '50%', validators: [{ type: 'regex', text: 'Inserisci un codice fiscale valido.', regex: '^[A-Z0-9]{11,16}$' }] },
                        { type: 'text', name: 'website_url', title: 'Sito web', startWithNewLine: true, width: '50%', validators: [{ type: 'regex', text: 'Inserisci un URL valido.', regex: '^(https?://)?[\\w.-]+\\.[a-z]{2,}(/.*)?$' }] },
                        { type: 'text', name: 'pec_email', title: 'PEC', startWithNewLine: false, width: '50%', validators: [{ type: 'email', text: 'Inserisci una email valida.' }] },
                        { type: 'text', name: 'general_email', title: 'Email generale', startWithNewLine: true, width: '50%', validators: [{ type: 'email', text: 'Inserisci una email valida.' }] },
                        { type: 'text', name: 'phone_number', title: 'Telefono', startWithNewLine: false, width: '50%' },
                        { type: 'comment', name: 'short_description', title: 'Descrizione breve' }
                    ]
                },
                {
                    name: 'contatti',
                    title: 'Contatti',
                    navigationTitle: 'Contatti',
                    elements: [
                        {
                            type: 'paneldynamic',
                            name: 'contacts',
                            title: 'Contatti principali',
                            addPanelText: 'Aggiungi nuovo',
                            removePanelText: 'Rimuovi',
                            renderMode: 'progressTop',
                            templateElements: [
                                { type: 'text', name: 'id', visible: false },
                                { type: 'text', name: 'full_name', title: 'Nome e cognome', isRequired: true },
                                {
                                    type: 'dropdown',
                                    name: 'role_type',
                                    title: 'Ruolo',
                                    choices: [
                                        { value: 'legal_representative', text: 'Legale rappresentante' },
                                        { value: 'procurement_contact', text: 'Referente gare / acquisti' },
                                        { value: 'technical_contact', text: 'Referente tecnico' },
                                        { value: 'administrative_contact', text: 'Referente amministrativo' },
                                        { value: 'other', text: 'Altro' }
                                    ]
                                },
                                { type: 'text', name: 'job_title', title: 'Titolo' },
                                { type: 'text', name: 'email', title: 'Email', validators: [{ type: 'email', text: 'Inserisci una email valida.' }] },
                                { type: 'text', name: 'phone_number', title: 'Telefono' },
                                { type: 'boolean', name: 'is_primary', title: 'Primario' },
                                {
                                    type: 'html',
                                    name: 'contact_birth_heading',
                                    html: '<div class="vg-cp-contact-section-title">Nascita</div>'
                                },
                                {
                                    type: 'text',
                                    name: 'tax_code',
                                    title: 'Codice fiscale',
                                    startWithNewLine: true,
                                    width: '50%',
                                    validators: [{ type: 'regex', text: 'Inserisci un codice fiscale valido.', regex: '^[A-Z0-9]{11,16}$' }]
                                },
                                {
                                    type: 'text',
                                    name: 'birth_date',
                                    title: 'Data di nascita',
                                    inputType: 'date',
                                    min: '1900-01-01',
                                    max: birthDateMax,
                                    startWithNewLine: false,
                                    width: '50%',
                                    validators: [
                                        {
                                            type: 'expression',
                                            text: 'La data di nascita non può essere nel futuro.',
                                            expression: '!{birth_date} or {birth_date} <= \'' + birthDateMax + '\''
                                        }
                                    ]
                                },
                                {
                                    type: 'text',
                                    name: 'birth_city',
                                    title: 'Comune di nascita',
                                    startWithNewLine: true,
                                    width: '50%'
                                },
                                {
                                    type: 'text',
                                    name: 'birth_postal_code',
                                    title: 'CAP comune di nascita',
                                    startWithNewLine: false,
                                    width: '50%',
                                    validators: [{ type: 'regex', text: 'CAP a 5 cifre.', regex: '^\\d{5}$' }]
                                },
                                {
                                    type: 'text',
                                    name: 'birth_province',
                                    title: 'Provincia di nascita',
                                    startWithNewLine: true,
                                    width: '50%',
                                },
                                {
                                    type: 'text',
                                    name: 'birth_country',
                                    title: 'Stato di nascita',
                                    startWithNewLine: false,
                                    width: '50%',
                                    defaultValue: 'IT'
                                },
                                {
                                    type: 'html',
                                    name: 'contact_residence_heading',
                                    html: '<div class="vg-cp-contact-section-title">Residenza</div>'
                                },
                                {
                                    type: 'text',
                                    name: 'residence_address',
                                    title: 'Indirizzo di residenza',
                                    startWithNewLine: true,
                                    width: '66%'
                                },
                                {
                                    type: 'text',
                                    name: 'residence_street_number',
                                    title: 'Numero civico',
                                    startWithNewLine: false,
                                    width: '34%'
                                },
                                {
                                    type: 'text',
                                    name: 'residence_city',
                                    title: 'Comune di residenza',
                                    startWithNewLine: true,
                                    width: '50%'
                                },
                                {
                                    type: 'text',
                                    name: 'residence_postal_code',
                                    title: 'CAP residenza',
                                    startWithNewLine: false,
                                    width: '50%',
                                    validators: [{ type: 'regex', text: 'CAP a 5 cifre.', regex: '^\\d{5}$' }]
                                },
                                {
                                    type: 'text',
                                    name: 'residence_province',
                                    title: 'Provincia di residenza',
                                    startWithNewLine: true,
                                    width: '50%'
                                }
                            ]
                        }
                    ]
                },
                {
                    name: 'allegati',
                    title: 'Allegati',
                    navigationTitle: 'Allegati',
                    elements: [
                        {
                            type: 'html',
                            name: 'attachments_help',
                            html: '' +
                                '<div style="opacity:.8; margin-bottom:10px;">Carica e gestisci i documenti aziendali qui sotto.</div>' +
                                '<div data-cp-att-list></div>' +
                                '<div style="height:12px;"></div>' +
                                '<div data-cp-att-upload></div>'
                        }
                    ]
                },
                {
                    name: 'cpv',
                    title: 'CPV di interesse',
                    navigationTitle: 'CPV',
                    elements: [
                        {
                            type: 'paneldynamic',
                            name: 'cpv',
                            title: 'Aggiungi CPV',
                            addPanelText: 'Aggiungi nuovo',
                            removePanelText: 'Rimuovi',
                            templateElements: [
                                { type: 'text', name: 'id', visible: false },
                                { type: 'text', name: 'cpv_code', title: 'Codice', isRequired: true, placeholder: 'Cerca per codice o descrizione (es. 45 o “costruzione”)…' },
                                { type: 'text', name: 'cpv_label', title: 'Descrizione', readOnly: true },
                                { type: 'rating', name: 'relevance_score', title: 'Rilevanza', rateMin: 1, rateMax: 5 },
                                { type: 'text', name: 'notes', title: 'Note' }
                            ]
                        }
                    ]
                },
                {
                    name: 'territori',
                    title: 'Territori di interesse',
                    navigationTitle: 'Territori',
                    elements: [
                        {
                            type: 'html',
                            name: 'territories_ui',
                            html: '' +
                                '<div style="opacity:.8; margin-bottom:10px;">Seleziona i territori sulla mappa: disegna un poligono, scegli una regione, oppure cerca una città e imposta un raggio.</div>' +
                                '<div data-cp-territories></div>'
                        }
                    ]
                },
                {
                    name: 'metriche',
                    title: 'Metriche economico-finanziarie',
                    navigationTitle: 'Metriche',
                    elements: [
                        {
                            type: 'paneldynamic',
                            name: 'financial_metrics',
                            title: 'Metriche',
                            addPanelText: 'Aggiungi nuovo',
                            removePanelText: 'Rimuovi',
                            templateElements: [
                                { type: 'text', name: 'id', visible: false },
                                {
                                    type: 'text',
                                    name: 'fiscal_year',
                                    title: 'Anno',
                                    isRequired: true,
                                    width: '25%',
                                    inputMode: 'numeric',
                                    maxLength: 4,
                                    placeholder: 'YYYY',
                                    validators: [
                                        { type: 'numeric', minValue: 1900, maxValue: 2100, text: 'Inserisci un anno valido (es. 2024).' }
                                    ]
                                },
                                {
                                    type: 'text',
                                    name: 'metric_code',
                                    title: 'Metrica (cerca)',
                                    isRequired: true,
                                    placeholder: 'Cerca per codice o nome (es. EBITDA, ROI, PFN, ...)',
                                    description: 'Digita per vedere suggerimenti (autocomplete).',
                                    width: '50%'
                                },
                                { type: 'text', name: 'metric_label', title: 'Etichetta (auto)', width: '50%' },
                                { type: 'text', inputType: 'number', name: 'amount', title: 'Valore', width: '50%' },
                                { type: 'text', name: 'currency_code', title: 'Valuta', defaultValue: 'EUR', width: '25%' },
                                { type: 'text', name: 'notes', title: 'Note', width: '100%' }
                            ]
                        }
                    ]
                },
                {
                    name: 'capacita',
                    title: 'Capacità tecniche / professionali',
                    navigationTitle: 'Capacità',
                    elements: [
                        {
                            type: 'paneldynamic',
                            name: 'capabilities',
                            title: 'Capacità',
                            addPanelText: 'Aggiungi nuovo',
                            removePanelText: 'Rimuovi',
                            templateElements: [
                                { type: 'text', name: 'id', visible: false },
                                {
                                    type: 'text',
                                    name: 'capability_code',
                                    title: 'Categoria (cerca)',
                                    isRequired: true,
                                    placeholder: 'Cerca per codice o descrizione (es. OG1, OS30, verde, impianti...)',
                                    description: 'Suggerimenti per categorie SOA (OG/OS). Puoi anche inserire manualmente.',
                                    width: '40%'
                                },
                                { type: 'text', name: 'capability_label', title: 'Etichetta', isRequired: true, width: '60%' },
                                { type: 'text', name: 'capability_type', title: 'Tipo', isRequired: true, defaultValue: 'SOA', width: '25%' },
                                { type: 'text', inputType: 'number', name: 'years_experience', title: 'Anni esperienza', width: '25%' },
                                { type: 'comment', name: 'description', title: 'Descrizione', width: '100%' }
                            ]
                        }
                    ]
                },
                {
                    name: 'certificazioni',
                    title: 'Certificazioni',
                    navigationTitle: 'Certificazioni',
                    elements: [
                        {
                            type: 'paneldynamic',
                            name: 'certifications',
                            title: 'Certificazioni',
                            addPanelText: 'Aggiungi nuovo',
                            removePanelText: 'Rimuovi',
                            templateElements: [
                                { type: 'text', name: 'id', visible: false },
                                {
                                    type: 'text',
                                    name: 'certification_name',
                                    title: 'Certificazione (cerca)',
                                    isRequired: true,
                                    placeholder: 'Cerca per codice o descrizione (es. ISO 9001, EMAS, SA 8000...)',
                                    description: 'Suggerimenti disponibili, ma puoi sempre inserire testo libero.',
                                    width: '60%'
                                },
                                { type: 'text', name: 'issuing_body', title: 'Ente', width: '40%' },
                                { type: 'text', name: 'certificate_number', title: 'Numero', width: '40%' },
                                { type: 'text', inputType: 'date', name: 'valid_from', title: 'Valida da' },
                                { type: 'text', inputType: 'date', name: 'valid_until', title: 'Scadenza' },
                                { type: 'text', name: 'notes', title: 'Note', width: '100%' },
                                {
                                    type: 'tagbox',
                                    name: 'attachment_ids',
                                    title: 'Allegati collegati',
                                    choices: []
                                }
                            ]
                        }
                    ]
                },
                {
                    name: 'referenze',
                    title: 'Referenze / contratti pregressi',
                    navigationTitle: 'Referenze',
                    elements: [
                        {
                            type: 'paneldynamic',
                            name: 'references',
                            title: 'Referenze',
                            addPanelText: 'Aggiungi nuovo',
                            removePanelText: 'Rimuovi',
                            templateElements: [
                                { type: 'text', name: 'id', visible: false },
                                { type: 'text', name: 'reference_title', title: 'Titolo', isRequired: true },
                                { type: 'text', name: 'client_name', title: 'Cliente' },
                                { type: 'text', inputType: 'date', name: 'start_date', title: 'Inizio' },
                                { type: 'text', inputType: 'date', name: 'end_date', title: 'Fine' },
                                { type: 'text', inputType: 'number', name: 'contract_value', title: 'Valore (EUR)' },
                                { type: 'comment', name: 'description', title: 'Descrizione' },
                                {
                                    type: 'tagbox',
                                    name: 'attachment_ids',
                                    title: 'Allegati collegati',
                                    choices: []
                                }
                            ]
                        }
                    ]
                },
                {
                    name: 'lingue',
                    title: 'Lingue operative',
                    navigationTitle: 'Lingue',
                    elements: [
                        {
                            type: 'paneldynamic',
                            name: 'languages',
                            title: 'Lingue',
                            addPanelText: 'Aggiungi nuovo',
                            removePanelText: 'Rimuovi',
                            templateElements: [
                                { type: 'text', name: 'id', visible: false },
                                {
                                    type: 'text',
                                    name: 'language_code',
                                    title: 'Lingua (cerca)',
                                    isRequired: true,
                                    placeholder: 'Cerca per codice o nome (es. it, en, italian, english...)',
                                    description: 'Suggerimenti disponibili, ma puoi sempre inserire testo libero.',
                                    width: '50%'
                                },
                                {
                                    type: 'text',
                                    name: 'proficiency_label',
                                    title: 'Livello (cerca)',
                                    placeholder: 'CEFR (A1–C2) oppure Madrelingua, Professionale...',
                                    description: 'Suggerimenti disponibili, ma puoi sempre inserire testo libero.',
                                    width: '50%'
                                },
                                { type: 'text', name: 'notes', title: 'Note', width: '100%' }
                            ]
                        }
                    ]
                },
                {
                    name: 'dichiarazioni',
                    title: 'Dichiarazioni',
                    navigationTitle: 'Dichiarazioni',
                    elements: [
                        {
                            type: 'paneldynamic',
                            name: 'declarations',
                            title: 'Dichiarazioni',
                            allowAddPanel: false,
                            allowRemovePanel: false,
                            templateElements: [
                                { type: 'text', name: 'declaration_template_id', visible: false },
                                { type: 'html', name: 'label_html', html: '{panel.declaration_label}' },
                                {
                                    type: 'radiogroup',
                                    name: 'answer',
                                    title: 'Risposta',
                                    isRequired: true,
                                    choices: [
                                        { value: 'yes', text: 'Sì' },
                                        { value: 'no', text: 'No' },
                                        { value: 'unknown', text: 'Non so' },
                                        { value: 'not_applicable', text: 'Non applicabile' }
                                    ]
                                },
                                { type: 'comment', name: 'answer_text', title: 'Dettagli / testo libero' },
                                { type: 'text', inputType: 'date', name: 'valid_from', title: 'Valida da' },
                                { type: 'text', inputType: 'date', name: 'valid_until', title: 'Valida fino' },
                                { type: 'comment', name: 'notes', title: 'Note' }
                            ]
                        }
                    ]
                }
            ]
        };
    }

    function bundleToSurveyData(bundle) {
        var profile = bundle.profile || {};
        function arr(key) {
            return Array.isArray(bundle[key]) ? bundle[key] : [];
        }
        // Declarations: merge templates with answers (fallback unknown)
        var templates = Array.isArray(bundle.declaration_templates_active) ? bundle.declaration_templates_active : [];
        var answers = Array.isArray(bundle.declaration_answers) ? bundle.declaration_answers : [];
        var byTid = {};
        answers.forEach(function (a) {
            if (a && a.declaration_template_id) byTid[String(a.declaration_template_id)] = a;
        });
        var declarations = templates.map(function (t) {
            var tid = String(t.id);
            var a = byTid[tid] || {};
            return {
                declaration_template_id: tid,
                declaration_label: t.declaration_label || t.declaration_code || '',
                answer: a.answer || 'unknown',
                answer_text: a.answer_text || '',
                valid_from: a.valid_from || null,
                valid_until: a.valid_until || null,
                notes: a.notes || ''
            };
        });

        return {
            organization_name: profile.organization_name || '',
            legal_form: profile.legal_form || '',
            vat_number: profile.vat_number || '',
            tax_code: profile.tax_code || '',
            website_url: profile.website_url || '',
            pec_email: profile.pec_email || '',
            general_email: profile.general_email || '',
            phone_number: profile.phone_number || '',
            short_description: profile.short_description || '',
            contacts: arr('contacts'),
            cpv: arr('cpv'),
            territories: arr('territories'),
            financial_metrics: arr('financial_metrics'),
            capabilities: arr('capabilities'),
            certifications: arr('certifications'),
            references: arr('references'),
            languages: arr('languages'),
            declarations: declarations
        };
    }

    function applyAttachmentChoices(survey, bundle) {
        var atts = Array.isArray(bundle.attachments) ? bundle.attachments : [];
        var choices = atts.map(function (a) {
            return { value: String(a.id), text: String(a.file_name || a.title || a.id) };
        });

        function setChoices(panelName) {
            var q = survey.getQuestionByName(panelName);
            if (!q || !q.templateElements) return;
            q.templateElements.forEach(function (el) {
                if (el && el.name === 'attachment_ids') {
                    el.choices = choices;
                }
            });
        }
        setChoices('certifications');
        setChoices('references');
    }

    async function syncPanelItems(profileId, section, items, existingById, endpoints) {
        // endpoints: { listPath, createPath, patchPath(id), deletePath(id) }
        var seen = {};
        for (var i = 0; i < items.length; i++) {
            var it = items[i] || {};
            var id = it.id ? String(it.id) : '';
            var clean = Object.assign({}, it);
            delete clean.id;
            // empty rows: skip
            if (!id) {
                // create if has at least one meaningful value
                var hasAny = Object.keys(clean).some(function (k) {
                    var v = clean[k];
                    return v != null && String(v).trim() !== '';
                });
                if (!hasAny) continue;
                await apiJson(endpoints.createPath, { method: 'POST', jsonBody: clean });
                continue;
            }
            seen[id] = true;
            var prev = existingById[id] || null;
            if (!prev) {
                // treat as create (id provided unexpectedly)
                await apiJson(endpoints.createPath, { method: 'POST', jsonBody: clean });
                continue;
            }
            // patch always (simple & safe)
            await apiJson(endpoints.patchPath(id), { method: 'PATCH', jsonBody: clean });
        }
        // deletions
        Object.keys(existingById).forEach(function (id2) {
            if (!seen[id2]) {
                // best-effort delete
                apiJson(endpoints.deletePath(id2), { method: 'DELETE' }).catch(function () {});
            }
        });
    }

    async function savePage(profileId, bundle, pageName, data) {
        if (pageName === 'anagrafica') {
            await patchProfile(profileId, {
                organization_name: data.organization_name,
                legal_form: data.legal_form || null,
                vat_number: data.vat_number || null,
                tax_code: data.tax_code || null,
                website_url: data.website_url || null,
                pec_email: data.pec_email || null,
                general_email: data.general_email || null,
                phone_number: data.phone_number || null,
                short_description: data.short_description || null
            });
            return;
        }

        function toById(list) {
            var m = {};
            (list || []).forEach(function (x) {
                if (x && x.id) m[String(x.id)] = x;
            });
            return m;
        }

        if (pageName === 'contatti') {
            await syncPanelItems(
                profileId,
                'contacts',
                data.contacts || [],
                toById(bundle.contacts || []),
                {
                    createPath: '/company-profiles/' + profileId + '/contacts',
                    patchPath: function (id) { return '/company-profiles/' + profileId + '/contacts/' + id; },
                    deletePath: function (id) { return '/company-profiles/' + profileId + '/contacts/' + id; }
                }
            );
            return;
        }
        if (pageName === 'cpv') {
            await syncPanelItems(
                profileId,
                'cpv',
                data.cpv || [],
                toById(bundle.cpv || []),
                {
                    createPath: '/company-profiles/' + profileId + '/cpv',
                    patchPath: function (id) { return '/company-profiles/' + profileId + '/cpv/' + id; },
                    deletePath: function (id) { return '/company-profiles/' + profileId + '/cpv/' + id; }
                }
            );
            return;
        }
        if (pageName === 'territori') {
            await syncPanelItems(
                profileId,
                'territories',
                data.territories || [],
                toById(bundle.territories || []),
                {
                    createPath: '/company-profiles/' + profileId + '/territories',
                    patchPath: function (id) { return '/company-profiles/' + profileId + '/territories/' + id; },
                    deletePath: function (id) { return '/company-profiles/' + profileId + '/territories/' + id; }
                }
            );
            return;
        }
        if (pageName === 'metriche') {
            await syncPanelItems(
                profileId,
                'financial_metrics',
                data.financial_metrics || [],
                toById(bundle.financial_metrics || []),
                {
                    createPath: '/company-profiles/' + profileId + '/financial-metrics',
                    patchPath: function (id) { return '/company-profiles/' + profileId + '/financial-metrics/' + id; },
                    deletePath: function (id) { return '/company-profiles/' + profileId + '/financial-metrics/' + id; }
                }
            );
            return;
        }
        if (pageName === 'capacita') {
            await syncPanelItems(
                profileId,
                'capabilities',
                data.capabilities || [],
                toById(bundle.capabilities || []),
                {
                    createPath: '/company-profiles/' + profileId + '/capabilities',
                    patchPath: function (id) { return '/company-profiles/' + profileId + '/capabilities/' + id; },
                    deletePath: function (id) { return '/company-profiles/' + profileId + '/capabilities/' + id; }
                }
            );
            return;
        }
        if (pageName === 'certificazioni') {
            await syncPanelItems(
                profileId,
                'certifications',
                data.certifications || [],
                toById(bundle.certifications || []),
                {
                    createPath: '/company-profiles/' + profileId + '/certifications',
                    patchPath: function (id) { return '/company-profiles/' + profileId + '/certifications/' + id; },
                    deletePath: function (id) { return '/company-profiles/' + profileId + '/certifications/' + id; }
                }
            );
            // Best-effort link attachments (no unlink without extra endpoint)
            (data.certifications || []).forEach(function (c) {
                var cid = c && c.id ? String(c.id) : '';
                if (!cid) return;
                (c.attachment_ids || []).forEach(function (aid) {
                    apiJson(
                        '/company-profiles/' + profileId + '/certifications/' + cid + '/attachments/' + String(aid),
                        { method: 'POST' }
                    ).catch(function () {});
                });
            });
            return;
        }
        if (pageName === 'referenze') {
            await syncPanelItems(
                profileId,
                'references',
                data.references || [],
                toById(bundle.references || []),
                {
                    createPath: '/company-profiles/' + profileId + '/references',
                    patchPath: function (id) { return '/company-profiles/' + profileId + '/references/' + id; },
                    deletePath: function (id) { return '/company-profiles/' + profileId + '/references/' + id; }
                }
            );
            (data.references || []).forEach(function (r) {
                var rid = r && r.id ? String(r.id) : '';
                if (!rid) return;
                (r.attachment_ids || []).forEach(function (aid) {
                    apiJson(
                        '/company-profiles/' + profileId + '/references/' + rid + '/attachments/' + String(aid),
                        { method: 'POST' }
                    ).catch(function () {});
                });
            });
            return;
        }
        if (pageName === 'lingue') {
            await syncPanelItems(
                profileId,
                'languages',
                data.languages || [],
                toById(bundle.languages || []),
                {
                    createPath: '/company-profiles/' + profileId + '/languages',
                    patchPath: function (id) { return '/company-profiles/' + profileId + '/languages/' + id; },
                    deletePath: function (id) { return '/company-profiles/' + profileId + '/languages/' + id; }
                }
            );
            return;
        }
        if (pageName === 'dichiarazioni') {
            var templates = Array.isArray(bundle.declaration_templates_active) ? bundle.declaration_templates_active : [];
            var items = (data.declarations || []).map(function (d, idx) {
                // SurveyJS can drop hidden values on rerender/navigation; keep a robust fallback.
                var tid = d && d.declaration_template_id ? d.declaration_template_id : null;
                if (!tid && templates[idx] && templates[idx].id) tid = String(templates[idx].id);
                return {
                    declaration_template_id: tid,
                    answer: d.answer || 'unknown',
                    answer_text: d.answer_text || null,
                    valid_from: d.valid_from || null,
                    valid_until: d.valid_until || null,
                    notes: d.notes || null,
                    source: 'company_profile'
                };
            });
            await apiJson('/company-profiles/' + profileId + '/declaration-answers/bulk', {
                method: 'PUT',
                jsonBody: { items: items }
            });
        }
    }

    function renderAttachmentsUI(profileId, bundle, opts) {
        opts = opts || {};
        var hostList = opts.hostList || null;
        var hostUpload = opts.hostUpload || null;
        var fallback = mountFilesNode();
        var useFallback = (!hostList || !hostUpload) && !!fallback;
        if (useFallback) {
            fallback.hidden = false;
            hostList = fallback;
            hostUpload = fallback;
        }
        if (!hostList || !hostUpload) return;

        var atts = (bundle.attachments || []).slice(0);
        function esc(s) {
            return String(s == null ? '' : s)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/\"/g, '&quot;')
                .replace(/\'/g, '&#39;');
        }
        function fmtBytes(n) {
            var x = Number(n || 0);
            if (!x || x < 0) return '';
            if (x < 1024) return x + ' B';
            var kb = x / 1024;
            if (kb < 1024) return kb.toFixed(kb < 10 ? 1 : 0) + ' KB';
            var mb = kb / 1024;
            if (mb < 1024) return mb.toFixed(mb < 10 ? 1 : 0) + ' MB';
            var gb = mb / 1024;
            return gb.toFixed(gb < 10 ? 1 : 0) + ' GB';
        }

        // Inject minimal styles once (keep it scoped & lightweight).
        if (!document.getElementById('vg-cp-attachments-style')) {
            var st = document.createElement('style');
            st.id = 'vg-cp-attachments-style';
            st.textContent =
                '.vg-attlist{display:grid; gap:10px;}' +
                '.vg-attrow{display:flex; align-items:center; justify-content:space-between; gap:12px; padding:12px 12px; background:rgba(0,0,0,.03); border-radius:10px;}' +
                '.vg-attmeta{display:flex; align-items:flex-start; gap:10px; min-width:0;}' +
                '.vg-atticon{width:34px; height:34px; border-radius:10px; background:#fff; border:1px solid rgba(0,0,0,.08); display:flex; align-items:center; justify-content:center; font-weight:800; font-size:.72rem; letter-spacing:.02em; flex:0 0 auto;}' +
                '.vg-attname{font-weight:800; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;}' +
                '.vg-attinfo{opacity:.75; font-size:.9em; margin-top:2px;}' +
                '.vg-atttxt{min-width:0;}' +
                '.vg-attempty{opacity:.75; padding:10px 0;}' +
                '.vg-attactions{display:flex; gap:8px; align-items:center; flex:0 0 auto;}' +
                '.vg-attlink{font-weight:800;}' +
                '.vg-attupload{padding:16px 16px; border:1px solid rgba(0,0,0,.08); border-radius:12px; background:#fff;}' +
                '.vg-attupload__u{display:flex; gap:10px; align-items:center; flex-wrap:wrap;}' +
                '.vg-attfile{position:relative; display:inline-flex; align-items:center;}' +
                '.vg-attfile__input{position:absolute; inset:0; opacity:0; cursor:pointer; width:100%;}' +
                '.vg-attfile__name{opacity:.75; font-size:.95em; max-width:45ch; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;}' +
                '.vg-attupload__hint{opacity:.75; font-size:.9em; margin-top:8px;}';
            document.head.appendChild(st);
        }

        function iconLabel(a) {
            var mime = String((a && a.mime_type) || '').toLowerCase();
            var name = String((a && a.file_name) || (a && a.title) || '').toLowerCase();
            function extOf(n) {
                var m = /(?:\.)([a-z0-9]{1,6})$/i.exec(n || '');
                return m ? m[1].toLowerCase() : '';
            }
            var ext = extOf(name);
            if (mime === 'application/pdf' || ext === 'pdf') return 'PDF';
            if (mime.indexOf('image/') === 0 || ['png', 'jpg', 'jpeg', 'webp', 'gif', 'svg'].indexOf(ext) !== -1) return 'IMG';
            if (mime.indexOf('word') !== -1 || ['doc', 'docx', 'odt', 'rtf'].indexOf(ext) !== -1) return 'DOC';
            if (mime.indexOf('excel') !== -1 || ['xls', 'xlsx', 'ods', 'csv'].indexOf(ext) !== -1) return 'XLS';
            if (['zip', '7z', 'rar'].indexOf(ext) !== -1) return 'ZIP';
            if (mime.indexOf('text/') === 0 || ['txt', 'md'].indexOf(ext) !== -1) return 'TXT';
            return 'FILE';
        }

        // LIST (goes between help text and nav buttons)
        var listHtml = '';
        if (atts.length) {
            listHtml += '<div style="margin:0 0 10px;"><button type="button" class="appaltimap-btn" data-cp-download-all-zip>Scarica tutti (ZIP)</button></div>';
        }
        if (!atts.length) {
            listHtml += '<div class="vg-attempty">Nessun allegato ancora.</div>';
        } else {
            listHtml += '<div class="vg-attlist">';
            atts.forEach(function (a) {
                var name = (a.file_name || a.title || a.id || 'file');
                var url = normalizeApiUrlMaybe(a.storage_url || '');
                var size = fmtBytes(a.file_size_bytes);
                var kind = a.document_kind ? String(a.document_kind) : '';
                var mime = a.mime_type ? String(a.mime_type) : '';
                var info = [kind, mime, size].filter(Boolean).join(' · ');
                listHtml += '<div class="vg-attrow">';
                listHtml += '<div class="vg-attmeta">';
                listHtml += '<div class="vg-atticon" title="' + esc(mime || kind || 'file') + '">' + esc(iconLabel(a)) + '</div>';
                listHtml += '<div class="vg-atttxt">';
                listHtml += '<div class="vg-attname">' +
                    (url ? ('<a class="vg-attlink" href="' + esc(url) + '" target="_blank" rel="noopener">' + esc(name) + '</a>') : esc(name)) +
                    '</div>';
                listHtml += info ? ('<div class="vg-attinfo">' + esc(info) + '</div>') : '';
                listHtml += '</div>';
                listHtml += '</div>';
                listHtml += '<div class="vg-attactions">';
                if (url) listHtml += '<a class="appaltimap-btn" href="' + esc(url) + '" target="_blank" rel="noopener">Apri</a>';
                listHtml += '<button type="button" class="appaltimap-btn" data-cp-del="' + esc(a.id) + '">Rimuovi</button>';
                listHtml += '</div>';
                listHtml += '</div>';
            });
            listHtml += '</div>';
        }
        hostList.innerHTML = listHtml;

        var zipBtn = hostList.querySelector('[data-cp-download-all-zip]');
        if (zipBtn) {
            zipBtn.addEventListener('click', async function () {
                try {
                    setStatus('Preparazione archivio allegati…');
                    await apiDownload('/company-profiles/' + encodeURIComponent(profileId) + '/attachments/download.zip', 'allegati.zip');
                    setStatus('Download allegati completato.');
                } catch (err) {
                    setStatus(String(err.message || err));
                    if (window.VistaGareUi && VistaGareUi.alert) {
                        VistaGareUi.alert(String(err.message || err), { title: 'Download non riuscito' });
                    }
                }
            });
        }

        // UPLOAD (goes under the list)
        var uploadHtml = '';
        uploadHtml += '<div class="vg-attupload">';
        uploadHtml += '<div class="vg-attupload__u">';
        uploadHtml += '<span class="vg-attfile">';
        uploadHtml += '<button type="button" class="appaltimap-btn" data-cp-pick>Scegli file</button>';
        uploadHtml += '<input class="vg-attfile__input" type="file" data-cp-file aria-label="Scegli file" />';
        uploadHtml += '</span>';
        uploadHtml += '<span class="vg-attfile__name" data-cp-file-name>Nessun file selezionato</span>';
        uploadHtml += '<button type="button" class="appaltimap-btn appaltimap-btn--primary" data-cp-upload>Carica</button>';
        uploadHtml += '</div>';
        uploadHtml += '<div class="vg-attupload__hint">Suggerimento: carica PDF, immagini o documenti utili (es. certificazioni, referenze).</div>';
        uploadHtml += '</div>';
        hostUpload.innerHTML = uploadHtml;

        var input = hostUpload.querySelector('[data-cp-file]');
        var pick = hostUpload.querySelector('[data-cp-pick]');
        var fileNameEl = hostUpload.querySelector('[data-cp-file-name]');
        var btn = hostUpload.querySelector('[data-cp-upload]');
        function syncPickedName() {
            if (!fileNameEl) return;
            var f = input && input.files && input.files[0] ? input.files[0] : null;
            fileNameEl.textContent = f ? String(f.name || 'file') : 'Nessun file selezionato';
        }
        if (pick && input) {
            pick.addEventListener('click', function () {
                try { input.click(); } catch (e) {}
            });
        }
        if (input) {
            input.addEventListener('change', syncPickedName);
            syncPickedName();
        }
        if (btn) {
            btn.addEventListener('click', async function () {
                try {
                    if (!input || !input.files || !input.files[0]) {
                        setStatus('Seleziona un file prima di caricare.');
                        return;
                    }
                    btn.disabled = true;
                    setStatus('Caricamento file…');
                    var file = input.files[0];
                    var fd = new FormData();
                    fd.append('file', file);
                    var up = await fetch(apiBase() + '/company-profiles/' + profileId + '/attachments/upload', {
                        method: 'POST',
                        credentials: 'include',
                        body: fd
                    });
                    var upJson = await up.json().catch(function () { return null; });
                    if (!up.ok) throw new Error((upJson && upJson.detail) ? upJson.detail : 'Upload failed');
                    await apiJson('/company-profiles/' + profileId + '/attachments', {
                        method: 'POST',
                        jsonBody: {
                            document_kind: 'other',
                            file_name: upJson.file_name,
                            mime_type: upJson.mime_type,
                            file_size_bytes: upJson.file_size_bytes,
                            storage_url: normalizeApiUrlMaybe(upJson.storage_url),
                            sha256_hex: upJson.sha256_hex
                        }
                    });
                    // Refresh list after upload (and allow parent to update its bundle too).
                    try {
                        var b2 = await getBundle(profileId);
                        if (opts && typeof opts.setBundle === 'function') opts.setBundle(b2);
                        if (opts && typeof opts.afterBundleChange === 'function') opts.afterBundleChange(b2);
                        renderAttachmentsUI(profileId, b2, opts);
                    } catch (e2) {}
                    setStatus('File caricato.');
                    if (input) input.value = '';
                    syncPickedName();
                } catch (e) {
                    setStatus('Errore upload: ' + (e && e.message ? e.message : String(e)));
                } finally {
                    btn.disabled = false;
                }
            });
        }
        hostList.querySelectorAll('[data-cp-del]').forEach(function (b) {
            b.addEventListener('click', function () {
                var id = b.getAttribute('data-cp-del');
                if (!id) return;
                window.VistaGareUi.confirm({
                    title: 'Rimuovi allegato',
                    message: 'Vuoi rimuovere definitivamente questo allegato?',
                    cancelText: 'Annulla',
                    confirmText: 'Rimuovi',
                    danger: true
                }).then(function (ok) {
                    if (!ok) return;
                    apiJson('/company-profiles/' + profileId + '/attachments/' + id, { method: 'DELETE' })
                        .then(async function () {
                            setStatus('Allegato rimosso.');
                            try {
                                var b3 = await getBundle(profileId);
                                if (opts && typeof opts.setBundle === 'function') opts.setBundle(b3);
                                if (opts && typeof opts.afterBundleChange === 'function') opts.afterBundleChange(b3);
                                renderAttachmentsUI(profileId, b3, opts);
                            } catch (e3) {}
                        })
                        .catch(function (e) { setStatus('Errore: ' + (e && e.message ? e.message : String(e))); });
                });
            });
        });
    }

    // -----------------------------
    // Territories (map-driven) UI
    // -----------------------------

    var _vgRegionsGeojsonPromise = null;
    var _vgRegionsGeojson = null;

    function territoriesRegionsUrl() {
        // Same dataset referenced elsewhere in the theme.
        return 'https://raw.githubusercontent.com/openpolis/geojson-italy/master/geojson/limits_IT_regions.geojson';
    }

    function geoCirclePolygon(centerLon, centerLat, radiusKm, segments) {
        segments = segments || 64;
        var R = 6371;
        var lat1 = (centerLat * Math.PI) / 180;
        var lon1 = (centerLon * Math.PI) / 180;
        var dByR = radiusKm / R;
        var coords = [];
        for (var i = 0; i <= segments; i++) {
            var brng = (i / segments) * 2 * Math.PI;
            var lat2 = Math.asin(Math.sin(lat1) * Math.cos(dByR) + Math.cos(lat1) * Math.sin(dByR) * Math.cos(brng));
            var lon2 = lon1 + Math.atan2(Math.sin(brng) * Math.sin(dByR) * Math.cos(lat1), Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat2));
            coords.push([(lon2 * 180) / Math.PI, (lat2 * 180) / Math.PI]);
        }
        return { type: 'Polygon', coordinates: [coords] };
    }

    function bboxFromGeometry(geom) {
        var minLon = Infinity, minLat = Infinity, maxLon = -Infinity, maxLat = -Infinity;
        function visitCoord(c) {
            if (!c || c.length < 2) return;
            var lon = Number(c[0]);
            var lat = Number(c[1]);
            if (!isFinite(lon) || !isFinite(lat)) return;
            minLon = Math.min(minLon, lon);
            minLat = Math.min(minLat, lat);
            maxLon = Math.max(maxLon, lon);
            maxLat = Math.max(maxLat, lat);
        }
        function walkCoords(coords) {
            if (!coords) return;
            if (typeof coords[0] === 'number') {
                visitCoord(coords);
                return;
            }
            for (var i = 0; i < coords.length; i++) walkCoords(coords[i]);
        }
        try { walkCoords(geom.coordinates); } catch (e) {}
        if (!isFinite(minLon) || !isFinite(minLat) || !isFinite(maxLon) || !isFinite(maxLat)) return null;
        if (!(minLon < maxLon && minLat < maxLat)) return null;
        return [[minLon, minLat], [maxLon, maxLat]];
    }

    function ensureTerritoriesStyle() {
        if (document.getElementById('vg-cp-territories-style')) return;
        var st = document.createElement('style');
        st.id = 'vg-cp-territories-style';
        st.textContent =
            '.vg-ter{display:grid; gap:12px;}' +
            '.vg-ter__grid{display:grid; grid-template-columns: 1fr; gap:12px;}' +
            '@media (min-width: 980px){.vg-ter__grid{grid-template-columns: 420px 1fr;}}' +
            '.vg-ter__card{padding:14px 14px; border:1px solid rgba(0,0,0,.08); border-radius:12px; background:#fff;}' +
            '.vg-ter__title{font-weight:800; margin:0 0 8px;}' +
            '.vg-ter__row{display:flex; gap:10px; align-items:center; flex-wrap:wrap;}' +
            '.vg-ter__row input[type=\"text\"],.vg-ter__row input[type=\"number\"],.vg-ter__row select{padding:10px 10px; border:1px solid rgba(0,0,0,.15); border-radius:10px; background:#fff; min-width: 240px;}' +
            '.vg-ter__row input[type=\"number\"]{min-width: 120px; width: 140px;}' +
            '.vg-ter__hint{opacity:.75; font-size:.92em; margin-top:6px;}' +
            '.vg-ter__map{height: 380px; border-radius:12px; overflow:hidden; border:1px solid rgba(0,0,0,.08);}' +
            '.vg-ter__list{display:grid; gap:10px;}' +
            '.vg-ter__item{display:grid; grid-template-columns: 240px 1fr auto; gap:10px; align-items:center; padding:10px; background:rgba(0,0,0,.03); border-radius:12px;}' +
            '.vg-ter__mini{height:180px; border-radius:10px; overflow:hidden; border:1px solid rgba(0,0,0,.08); background:#fff;}' +
            '.vg-ter__label{font-weight:800; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;}' +
            '.vg-ter__meta{opacity:.75; font-size:.92em; margin-top:2px;}' +
            '.vg-ter__actions{display:flex; gap:8px; align-items:center; justify-content:flex-end; flex-wrap:wrap;}';
        document.head.appendChild(st);
    }

    function resizeTerritoriesMapHost(host) {
        if (!host) return;
        var main = host.querySelector('[data-ter-map]');
        if (main && main.vgMapInstance && typeof main.vgMapInstance.resize === 'function') {
            try { main.vgMapInstance.resize(); } catch (e) {}
        }
        host.querySelectorAll('[data-ter-mini]').forEach(function (el) {
            if (el.vgMapInstance && typeof el.vgMapInstance.resize === 'function') {
                try { el.vgMapInstance.resize(); } catch (e2) {}
            }
        });
    }

    function mapStyleOsmRaster() {
        return {
            version: 8,
            sources: {
                osm: {
                    type: 'raster',
                    tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
                    tileSize: 256,
                    attribution: '&copy; OpenStreetMap contributors'
                }
            },
            layers: [{ id: 'osm', type: 'raster', source: 'osm' }]
        };
    }

    async function getRegionsGeojson() {
        if (_vgRegionsGeojson) return _vgRegionsGeojson;
        if (_vgRegionsGeojsonPromise) return await _vgRegionsGeojsonPromise;
        _vgRegionsGeojsonPromise = fetch(territoriesRegionsUrl(), { headers: { Accept: 'application/json' } })
            .then(function (r) { if (!r.ok) throw r; return r.json(); })
            .then(function (gj) { _vgRegionsGeojson = gj; return gj; })
            .catch(function () { return null; });
        return await _vgRegionsGeojsonPromise;
    }

    async function geocodePlaceSimple(place) {
        // Lightweight geocode endpoint (we’ll add it in gateway if missing).
        var q = String(place || '').trim();
        if (!q) return null;
        try {
            var data = await apiJson('/geo/geocode?q=' + encodeURIComponent(q));
            return data;
        } catch (e) {
            return null;
        }
    }

    function renderTerritoriesUI(profileId, bundle, survey, host) {
        ensureTerritoriesStyle();
        if (!host) return;
        if (!profileId) {
            host.innerHTML = '<div class="vg-ter__card">Crea prima il profilo per selezionare territori.</div>';
            return;
        }

        // Ensure we have the data array key SurveyJS expects for saving.
        if (!survey.data) survey.data = {};
        if (!Array.isArray(survey.data.territories)) survey.data.territories = [];

        var html = '';
        html += '<div class="vg-ter">';
        html += '  <div class="vg-ter__grid">';
        html += '    <div class="vg-ter__card">';
        html += '      <div class="vg-ter__title">Aggiungi territorio</div>';
        html += '      <div class="vg-ter__row">';
        html += '        <button type="button" class="appaltimap-btn" data-ter-mode="polygon">Disegna poligono</button>';
        html += '        <button type="button" class="appaltimap-btn" data-ter-mode="select">Modifica</button>';
        html += '        <button type="button" class="appaltimap-btn appaltimap-btn--primary" data-ter-add-polygon>Aggiungi poligono</button>';
        html += '      </div>';
        html += '      <div class="vg-ter__hint">Suggerimento: disegna un poligono e poi premi “Aggiungi poligono”.</div>';
        html += '      <div style="height:12px;"></div>';
        html += '      <div class="vg-ter__title">Regione</div>';
        html += '      <div class="vg-ter__row">';
        html += '        <select data-ter-region><option value="">Seleziona una regione…</option></select>';
        html += '        <button type="button" class="appaltimap-btn appaltimap-btn--primary" data-ter-add-region>Aggiungi regione</button>';
        html += '      </div>';
        html += '      <div style="height:12px;"></div>';
        html += '      <div class="vg-ter__title">Città + raggio</div>';
        html += '      <div class="vg-ter__row">';
        html += '        <input type="text" data-ter-city placeholder="Cerca città (es. Milano)..." />' +
            '        <input type="number" min="1" max="300" step="1" value="30" data-ter-radius aria-label="Raggio (km)" />' +
            '        <span style="opacity:.75;">km</span>';
        html += '        <button type="button" class="appaltimap-btn appaltimap-btn--primary" data-ter-add-city>Aggiungi</button>';
        html += '      </div>';
        html += '      <div class="vg-ter__hint">Useremo il centro città e creeremo un’area circolare (approssimata a poligono).</div>';
        html += '      <div style="height:12px;"></div>';
        html += '      <div class="vg-ter__row">';
        html += '        <button type="button" class="appaltimap-btn" data-ter-reset-italy>Tutta Italia</button>';
        html += '        <button type="button" class="appaltimap-btn" data-ter-clear>Rimuovi tutti</button>';
        html += '      </div>';
        html += '    </div>';
        html += '    <div class="vg-ter__card">';
        html += '      <div class="vg-ter__title">Mappa</div>';
        html += '      <div class="vg-ter__map" data-ter-map></div>';
        html += '    </div>';
        html += '  </div>';
        html += '  <div class="vg-ter__card">';
        html += '    <div class="vg-ter__title">Territori selezionati</div>';
        html += '    <div class="vg-ter__list" data-ter-list></div>';
        html += '  </div>';
        html += '</div>';
        host.innerHTML = html;

        var mapEl = host.querySelector('[data-ter-map]');
        var listEl = host.querySelector('[data-ter-list]');
        var regionSel = host.querySelector('[data-ter-region]');
        var cityInput = host.querySelector('[data-ter-city]');
        var radiusInput = host.querySelector('[data-ter-radius]');

        function getTerritories() {
            return Array.isArray(survey.data.territories) ? survey.data.territories : [];
        }
        function setTerritories(arr) {
            survey.data = Object.assign({}, survey.data, { territories: arr });
        }

        function nextPolyLabel() {
            var n = getTerritories().filter(function (t) { return t && t.territory_kind === 'polygon'; }).length + 1;
            return 'Poligono ' + n;
        }

        function makeItem(kind, label, code, geom) {
            return {
                territory_kind: kind,
                territory_label: label,
                territory_code: code || null,
                geometry_geojson: geom || null,
                notes: null
            };
        }

        function renderList() {
            var items = getTerritories().slice(0);
            if (!items.length) {
                listEl.innerHTML = '<div style="opacity:.75;">Nessun territorio selezionato.</div>';
                return;
            }
            var out = '';
            items.forEach(function (t, idx) {
                var label = (t && t.territory_label) ? String(t.territory_label) : ('Territorio ' + (idx + 1));
                var kind = t && t.territory_kind ? String(t.territory_kind) : '';
                out += '<div class="vg-ter__item" data-ter-idx="' + idx + '">';
                out += '  <div class="vg-ter__mini" data-ter-mini="' + idx + '"></div>';
                out += '  <div>';
                out += '    <div class="vg-ter__label">' + label.replace(/</g, '&lt;') + '</div>';
                out += '    <div class="vg-ter__meta">' + (kind ? (kind + (t.territory_code ? ' · ' + t.territory_code : '')) : '') + '</div>';
                out += '  </div>';
                out += '  <div class="vg-ter__actions">';
                out += '    <button type="button" class="appaltimap-btn" data-ter-del="' + idx + '">Rimuovi</button>';
                out += '  </div>';
                out += '</div>';
            });
            listEl.innerHTML = out;

            listEl.querySelectorAll('[data-ter-del]').forEach(function (b) {
                b.addEventListener('click', function () {
                    var i = Number(b.getAttribute('data-ter-del'));
                    var arr = getTerritories().slice(0);
                    arr.splice(i, 1);
                    setTerritories(arr);
                    renderList();
                    initMiniMaps();
                });
            });

            initMiniMaps();
        }

        function initMiniMap(elMini, geom) {
            if (!elMini || !geom || !window.maplibregl) return;
            if (elMini.dataset.vgMiniReady === '1') return;
            elMini.dataset.vgMiniReady = '1';
            var map = new window.maplibregl.Map({
                container: elMini,
                style: mapStyleOsmRaster(),
                center: [12.5, 42.6],
                zoom: 4,
                interactive: false
            });
            elMini.vgMapInstance = map;
            map.on('load', function () {
                map.resize();
                window.requestAnimationFrame(function () { try { map.resize(); } catch (e) {} });
                map.addSource('sel', { type: 'geojson', data: { type: 'Feature', geometry: geom, properties: {} } });
                map.addLayer({ id: 'fill', type: 'fill', source: 'sel', paint: { 'fill-color': '#1b6fff', 'fill-opacity': 0.18 } });
                map.addLayer({ id: 'line', type: 'line', source: 'sel', paint: { 'line-color': '#1b6fff', 'line-width': 2 } });
                var bb = bboxFromGeometry(geom);
                if (bb) map.fitBounds(bb, { padding: 12, duration: 0 });
            });
        }

        function initMiniMaps() {
            var arr = getTerritories();
            arr.forEach(function (t, idx) {
                var elMini = listEl.querySelector('[data-ter-mini="' + idx + '"]');
                var geom = t && t.geometry_geojson ? t.geometry_geojson : null;
                initMiniMap(elMini, geom);
            });
        }

        // Main selector map + TerraDraw
        var draw = null;
        var currentFeatureId = null;
        function ensureMapAndDraw() {
            if (!mapEl || mapEl.dataset.vgMapReady === '1') return;
            if (!window.maplibregl) return;
            mapEl.dataset.vgMapReady = '1';
            var map = new window.maplibregl.Map({
                container: mapEl,
                style: mapStyleOsmRaster(),
                center: [12.5, 42.6],
                zoom: 4
            });
            mapEl.vgMapInstance = map;
            map.addControl(new window.maplibregl.NavigationControl(), 'top-right');
            map.on('load', function () {
                clampMapToEurope(map);
                map.resize();
                window.requestAnimationFrame(function () {
                    try { map.resize(); } catch (e) {}
                });
                if (!window.terraDraw || !window.terraDrawMaplibreGlAdapter) {
                    setStatus('Errore: libreria disegno mappa (TerraDraw) non caricata.');
                    return;
                }
                draw = new window.terraDraw.TerraDraw({
                    adapter: new window.terraDrawMaplibreGlAdapter.TerraDrawMapLibreGLAdapter({ map: map }),
                    modes: [
                        new window.terraDraw.TerraDrawPolygonMode(),
                        new window.terraDraw.TerraDrawRectangleMode(),
                        new window.terraDraw.TerraDrawFreehandMode(),
                        new window.terraDraw.TerraDrawSelectMode({
                            allowManualDeselection: true,
                            flags: {
                                polygon: { feature: { draggable: true, coordinates: { midpoints: true, draggable: true, deletable: true } } },
                                rectangle: { feature: { draggable: true, coordinates: { midpoints: true, draggable: true, deletable: true } } },
                                freehand: { feature: { draggable: true, coordinates: { midpoints: true, draggable: true, deletable: true } } }
                            }
                        }),
                        new window.terraDraw.TerraDrawRenderMode({ modeName: 'render', styles: {} })
                    ]
                });
                draw.start();
                draw.setMode('render');
                try {
                    draw.on('finish', function (id) {
                        currentFeatureId = id;
                        try { draw.setMode('select'); } catch (e) {}
                        try { if (draw.selectFeature) draw.selectFeature(id); } catch (e2) {}
                    });
                } catch (e3) {}
            });

            host.querySelectorAll('[data-ter-mode]').forEach(function (b) {
                b.addEventListener('click', function () {
                    if (!draw) return;
                    var m = b.getAttribute('data-ter-mode') || 'render';
                    try { draw.setMode(m); } catch (e) {}
                });
            });

            var addPolyBtn = host.querySelector('[data-ter-add-polygon]');
            if (addPolyBtn) {
                addPolyBtn.addEventListener('click', function () {
                    if (!draw) return;
                    var geom = null;
                    try {
                        var f = (currentFeatureId && draw.getSnapshotFeature) ? draw.getSnapshotFeature(currentFeatureId) : null;
                        if (f && f.geometry) geom = f.geometry;
                        if (!geom && draw.getSnapshot) {
                            var snap = draw.getSnapshot() || [];
                            if (snap.length && snap[snap.length - 1] && snap[snap.length - 1].geometry) geom = snap[snap.length - 1].geometry;
                        }
                    } catch (e) {}
                    if (!geom || !(geom.type === 'Polygon' || geom.type === 'MultiPolygon')) {
                        setStatus('Disegna prima un poligono valido.');
                        return;
                    }
                    var arr = getTerritories().slice(0);
                    arr.push(makeItem('polygon', nextPolyLabel(), null, geom));
                    setTerritories(arr);
                    renderList();
                });
            }
        }

        // Populate regions dropdown
        getRegionsGeojson().then(function (gj) {
            if (!gj || !regionSel) return;
            try {
                (gj.features || []).forEach(function (f) {
                    var name = (f && f.properties && (f.properties.reg_name || f.properties.name || f.properties.NOME_REG)) ? String(f.properties.reg_name || f.properties.name || f.properties.NOME_REG) : '';
                    if (!name) return;
                    var opt = document.createElement('option');
                    opt.value = name;
                    opt.textContent = name;
                    regionSel.appendChild(opt);
                });
            } catch (e) {}
        });

        var addRegionBtn = host.querySelector('[data-ter-add-region]');
        if (addRegionBtn) {
            addRegionBtn.addEventListener('click', function () {
                var v = regionSel ? String(regionSel.value || '').trim() : '';
                if (!v) return;
                getRegionsGeojson().then(function (gj) {
                    if (!gj) return;
                    var geom = null;
                    (gj.features || []).forEach(function (f) {
                        if (geom) return;
                        var name = (f && f.properties && (f.properties.reg_name || f.properties.name || f.properties.NOME_REG)) ? String(f.properties.reg_name || f.properties.name || f.properties.NOME_REG) : '';
                        if (String(name).toLowerCase() === v.toLowerCase()) {
                            geom = f.geometry || null;
                        }
                    });
                    if (!geom) return;
                    var arr = getTerritories().slice(0);
                    arr.push(makeItem('region', v, v, geom));
                    setTerritories(arr);
                    renderList();
                });
            });

            window.addEventListener('resize', function () {
                try { clampMapToEurope(map); } catch (eR) {}
            }, { passive: true });
        }

        var addCityBtn = host.querySelector('[data-ter-add-city]');
        if (addCityBtn) {
            addCityBtn.addEventListener('click', function () {
                var city = cityInput ? String(cityInput.value || '').trim() : '';
                var rKm = radiusInput ? Number(radiusInput.value || 0) : 0;
                if (!city) return;
                if (!isFinite(rKm) || rKm <= 0) rKm = 30;
                setStatus('Geocoding…');
                geocodePlaceSimple(city).then(function (geo) {
                    if (!geo || !geo.center || geo.center.length !== 2) {
                        setStatus('Impossibile geocodificare la città (configurare MAPBOX token sul gateway).');
                        return;
                    }
                    var lon = Number(geo.center[0]);
                    var lat = Number(geo.center[1]);
                    var geom = geoCirclePolygon(lon, lat, rKm, 64);
                    var label = 'Entro ' + Math.round(rKm) + 'km da ' + city;
                    var arr = getTerritories().slice(0);
                    arr.push(makeItem('city_radius', label, city, geom));
                    setTerritories(arr);
                    renderList();
                    setStatus('');
                });
            });
        }

        var clearBtn = host.querySelector('[data-ter-clear]');
        if (clearBtn) {
            clearBtn.addEventListener('click', function () {
                setTerritories([]);
                renderList();
            });
        }

        var italyBtn = host.querySelector('[data-ter-reset-italy]');
        if (italyBtn) {
            italyBtn.addEventListener('click', function () {
                // Approximate “Italy” as union of all region polygons: store as MultiPolygon of region geometries.
                getRegionsGeojson().then(function (gj) {
                    if (!gj) return;
                    var polys = [];
                    (gj.features || []).forEach(function (f) {
                        if (f && f.geometry && (f.geometry.type === 'Polygon' || f.geometry.type === 'MultiPolygon')) {
                            if (f.geometry.type === 'Polygon') polys.push(f.geometry.coordinates);
                            if (f.geometry.type === 'MultiPolygon') polys = polys.concat(f.geometry.coordinates);
                        }
                    });
                    if (!polys.length) return;
                    var geom = { type: 'MultiPolygon', coordinates: polys };
                    setTerritories([makeItem('nation', 'Italia', 'IT', geom)]);
                    renderList();
                });
            });
        }

        // City autocomplete using existing suggest endpoint (names only).
        if (cityInput) {
            var dlCityId = 'vg-ter-city-dl';
            var dlCity = document.getElementById(dlCityId);
            if (!dlCity) {
                dlCity = document.createElement('datalist');
                dlCity.id = dlCityId;
                document.body.appendChild(dlCity);
            }
            cityInput.setAttribute('list', dlCityId);
            var cityPending = null;
            cityInput.addEventListener('input', function () {
                var q = String(cityInput.value || '').trim();
                if (cityPending) window.clearTimeout(cityPending);
                if (q.length < 2) return;
                cityPending = window.setTimeout(function () {
                    fetch(apiBase() + '/radar/hub/city-suggest?q=' + encodeURIComponent(q) + '&limit=20', { headers: { Accept: 'application/json' } })
                        .then(function (r) { return r.ok ? r.json() : { items: [] }; })
                        .then(function (data) {
                            while (dlCity.firstChild) dlCity.removeChild(dlCity.firstChild);
                            (data.items || []).forEach(function (it) {
                                var opt = document.createElement('option');
                                opt.value = it.label || it.city_norm || '';
                                dlCity.appendChild(opt);
                            });
                        })
                        .catch(function () {});
                }, 180);
            });
        }

        renderList();
        ensureMapAndDraw();
        window.requestAnimationFrame(function () {
            resizeTerritoriesMapHost(host);
        });
    }

    async function main() {
        setBarHidden(true);
        setStatus('Carico sessione Ghost…');

        var token = await fetchGhostSessionToken();
        if (!token) {
            setStatus('Accesso richiesto…');
            openPortalSignin();
            return;
        }

        setStatus('Creo sessione…');
        await loginOnGateway(token);

        setStatus('Carico profilo…');
        var res = await verifyOnGateway(token);

        if (res && res.valid) {
            renderProfileBar(res);
            setBarHidden(false);
            setStatus('Preparazione wizard…');
        } else {
            setStatus('Token NON valido: ' + (res && res.reason ? res.reason : ''));
            return;
        }

        ensureSurveyAvailable();
        var mount = mountSurveyNode();
        if (!mount) {
            setStatus('Errore: mount Survey non trovato.');
            return;
        }

        var attachmentsEl = mountFilesNode();
        if (attachmentsEl) {
            attachmentsEl.innerHTML = '';
            attachmentsEl.hidden = true;
        }

        // Find or create profile (creation requires first step)
        var list = await listMyProfiles();
        var first = (list && list.items && list.items[0]) ? list.items[0] : null;
        var profileId = first ? String(first.id) : '';

        var isCreating = !profileId;
        if (isCreating) {
            setStatus('Stai creando il tuo profilo aziendale: inizia dall’anagrafica.');
        }

        var bundle = profileId ? await getBundle(profileId) : { profile: {}, contacts: [], cpv: [], territories: [], financial_metrics: [], capabilities: [], certifications: [], references: [], languages: [], attachments: [], declaration_templates_active: [], declaration_answers: [] };
        if (profileId) {
            refreshRagStatus(profileId);
            var reindexBtn = qs('[data-cp-rag-reindex]', root);
            if (reindexBtn && !reindexBtn.getAttribute('data-cp-rag-bound')) {
                reindexBtn.setAttribute('data-cp-rag-bound', '1');
                reindexBtn.addEventListener('click', async function () {
                    try {
                        setStatus('Richiesta aggiornamento indice…');
                        await apiJson('/company-profiles/' + encodeURIComponent(profileId) + '/rag-status/reindex', { method: 'POST' });
                        await refreshRagStatus(profileId);
                        setStatus('Indicizzazione in coda.');
                    } catch (e) {
                        setStatus('Errore indice: ' + (e && e.message ? e.message : String(e)));
                    }
                });
            }
        }
        // Attachments UI is shown only in the dedicated "allegati" page, inside SurveyJS page body.
        function syncAttachmentsVisibility(pageName) {
            // Always keep legacy external mount hidden (we now render inside the survey page).
            var legacy = mountFilesNode();
            if (legacy) legacy.hidden = true;

            var show = (pageName === 'allegati') && !!profileId;
            if (!show) return;

            var mount = mountSurveyNode();
            if (!mount) return;
            var hostList = mount.querySelector('[data-cp-att-list]');
            var hostUpload = mount.querySelector('[data-cp-att-upload]');
            if (!hostList || !hostUpload) return;

            renderAttachmentsUI(profileId, bundle, {
                hostList: hostList,
                hostUpload: hostUpload,
                setBundle: function (b) { bundle = b; },
                afterBundleChange: function (b) { applyAttachmentChoices(survey, b); }
            });
        }

        // Territories UI (map-driven) is shown only in the dedicated "territori" page, inside SurveyJS page body.
        function syncTerritoriesVisibility(pageName) {
            var show = (pageName === 'territori') && !!profileId;
            if (!show) return;
            var mount = mountSurveyNode();
            if (!mount) return;
            var host = mount.querySelector('[data-cp-territories]');
            if (!host) return;
            // SurveyJS can re-render the html question after our hook runs; avoid wiping a working mount.
            if (host.querySelector('.vg-ter')) {
                resizeTerritoriesMapHost(host);
                return;
            }
            renderTerritoriesUI(profileId, bundle, survey, host);
        }

        var survey = new Survey.Model(surveyJson());
        var PAGE_KEY = profileId ? ('vg-company-profile:last-page:' + profileId) : '';
        try {
            // Apply SurveyJS theme if available (v2+)
            if (window.Survey && window.Survey.StylesManager && window.Survey.StylesManager.applyTheme) {
                window.Survey.StylesManager.applyTheme('defaultV2');
            }
        } catch (e) {}
        survey.data = bundleToSurveyData(bundle);
        applyAttachmentChoices(survey, bundle);
        attachCpvAutocomplete(survey);
        attachFinancialMetricsAutocomplete(survey);
        attachCapabilitiesAutocomplete(survey);
        attachCertificationsAutocomplete(survey);
        attachLanguagesAutocomplete(survey);
        initProfileBarActions(profileId, {
            onRestored: async function () {
                bundle = await getBundle(profileId);
                survey.data = bundleToSurveyData(bundle);
                applyAttachmentChoices(survey, bundle);
                syncAttachmentsVisibility(survey.currentPage ? survey.currentPage.name : '');
                syncTerritoriesVisibility(survey.currentPage ? survey.currentPage.name : '');
                await refreshRagStatus(profileId);
            }
        });
        // Ensure attachments UI is shown only when user is on the attachments page.
        survey.onCurrentPageChanged.add(function (sender) {
            var pn = sender.currentPage ? sender.currentPage.name : '';
            syncAttachmentsVisibility(pn);
            syncTerritoriesVisibility(pn);
            // Repair datalist bindings after page navigation (SurveyJS can keep page DOM but drop input attributes).
            window.requestAnimationFrame(function () { repairAutocompleteBindings(); });
            if (PAGE_KEY && pn) {
                try { window.localStorage.setItem(PAGE_KEY, pn); } catch (e) {}
            }
        });
        // Ensure the attachments placeholders exist before rendering into them.
        survey.onAfterRenderPage.add(function (sender, options) {
            var pn = options && options.page ? options.page.name : '';
            if (pn === 'allegati') {
                syncAttachmentsVisibility('allegati');
            }
            if (pn === 'territori') {
                window.requestAnimationFrame(function () {
                    syncTerritoriesVisibility('territori');
                });
            }
            window.requestAnimationFrame(function () { repairAutocompleteBindings(); });
        });
        survey.onAfterRenderQuestion.add(function (sender, options) {
            var q = options && options.question ? options.question : null;
            if (!q || q.name !== 'territories_ui') return;
            var pn = sender.currentPage ? sender.currentPage.name : '';
            if (pn !== 'territori') return;
            window.requestAnimationFrame(function () {
                syncTerritoriesVisibility('territori');
            });
        });
        // initial state (after first render)
        syncAttachmentsVisibility(survey.currentPage ? survey.currentPage.name : '');
        syncTerritoriesVisibility(survey.currentPage ? survey.currentPage.name : '');

        var saving = false;
        var _skipPageChanging = false;
        var _navigating = false;
        async function doSave(pageName) {
            if (saving) return;
            saving = true;
            try {
                setStatus('Salvataggio…');
                await savePage(profileId, bundle, pageName, survey.data);
                bundle = await getBundle(profileId);
                syncAttachmentsVisibility(survey.currentPage ? survey.currentPage.name : '');
                applyAttachmentChoices(survey, bundle);
                refreshRagStatus(profileId);
                setStatus('Salvato.');
            } catch (e) {
                setStatus('Errore salvataggio: ' + (e && e.message ? e.message : String(e)));
            } finally {
                saving = false;
            }
        }

        survey.onCurrentPageChanging.add(function (sender, options) {
            if (_skipPageChanging) return;
            var current = sender.currentPage ? sender.currentPage.name : '';
            if (!current) return;
            if (_navigating) {
                options.allowChanging = false;
                return;
            }

            // If profile doesn't exist yet, allow leaving anagrafica only after create.
            if (!profileId) {
                if (current !== 'anagrafica') {
                    options.allowChanging = false;
                    setStatus('Per continuare, crea prima il profilo partendo dall’anagrafica.');
                    return;
                }
                // Validate required fields before create
                if (!sender.validateCurrentPage()) {
                    options.allowChanging = false;
                    setStatus('Controlla i campi obbligatori.');
                    return;
                }
                options.allowChanging = false;
                _navigating = true;
                setStatus('Creo profilo…');
                createProfileMin(sender.data.organization_name).then(function (created) {
                    profileId = String(created.id);
                    initProfileBarActions(profileId, {
                        onRestored: async function () {
                            bundle = await getBundle(profileId);
                            survey.data = bundleToSurveyData(bundle);
                            applyAttachmentChoices(survey, bundle);
                            syncAttachmentsVisibility(survey.currentPage ? survey.currentPage.name : '');
                            syncTerritoriesVisibility(survey.currentPage ? survey.currentPage.name : '');
                            await refreshRagStatus(profileId);
                        }
                    });
                    // Load bundle now that profile exists, and refresh choices + attachments area
                    getBundle(profileId).then(function (b2) {
                        bundle = b2;
                        syncAttachmentsVisibility(sender.currentPage ? sender.currentPage.name : '');
                        applyAttachmentChoices(survey, bundle);
                        setStatus('');
                        _skipPageChanging = true;
                        sender.currentPage = options.newCurrentPage;
                        _skipPageChanging = false;
                        _navigating = false;
                    }).catch(function (e2) {
                        setStatus('Errore: ' + (e2 && e2.message ? e2.message : String(e2)));
                        _navigating = false;
                    });
                }).catch(function (e) {
                    setStatus('Errore: ' + (e && e.message ? e.message : String(e)));
                    _navigating = false;
                });
                return;
            }

            // Normal flow: save current page before leaving
            options.allowChanging = false;
            _navigating = true;
            doSave(current).then(function () {
                _skipPageChanging = true;
                sender.currentPage = options.newCurrentPage;
                _skipPageChanging = false;
                _navigating = false;
            });
        });
        survey.onComplete.add(function () {
            var current = survey.currentPage ? survey.currentPage.name : 'dichiarazioni';
            doSave(current);
        });

        survey.render(mount);
        // Re-run after render to ensure HTML question content exists in DOM.
        syncAttachmentsVisibility(survey.currentPage ? survey.currentPage.name : '');
        syncTerritoriesVisibility(survey.currentPage ? survey.currentPage.name : '');
        // Restore last visited page (only when profile already exists).
        if (PAGE_KEY && profileId) {
            try {
                var saved = String(window.localStorage.getItem(PAGE_KEY) || '').trim();
                if (saved && saved !== 'anagrafica') {
                    var p = survey.getPageByName(saved);
                    if (p) survey.currentPage = p;
                }
            } catch (e2) {}
        }
        window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
                var pn2 = survey.currentPage ? survey.currentPage.name : '';
                syncAttachmentsVisibility(pn2);
                syncTerritoriesVisibility(pn2);
            });
        });
        setStatus('');
    }

    main().catch(function (err) {
        setStatus('Errore: ' + (err && err.message ? err.message : String(err)));
    });
})(window, document);

